import { useEffect, useState, useRef } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import Table from '@mui/material/Table';
import { getDataFromS3 } from '../../CompanyList/companyFunctions';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { red, grey } from '@mui/material/colors';
import * as React from 'react';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import { useHistory, useParams } from 'react-router-dom';
import { constants } from '../../../../constants';
import { toTicketCalendarDateTime } from '../ticketCreatedDate';
import { showMessage } from 'app/store/fuse/messageSlice';
import ModalViewScale from './viewScale';
import {
  AppBar,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  FormControl,
  Icon,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
  Box,
} from '@mui/material';
import moment from 'moment-timezone';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import TicketPopup from '../TicketPopup';
import TicketMultiplePrint from '../TicketMultiplePrint';
import ReactToPrint from 'react-to-print';
import ToggleButton from '@mui/material/ToggleButton';
import { useDispatch } from 'react-redux';
import { useSubscriptionPaywall } from 'app/main/subscriptionManagement/SubscriptionPaywallContext';
import { Controller, useForm } from 'react-hook-form';
import { motion } from 'framer-motion';
import { DateTimePicker, TimePicker } from '@mui/lab';
import { connect } from 'react-redux';
import withReducer from 'app/store/withReducer';
import JobTicketAction from 'app/stores/loadz/redux/JobsReport/actions';
import JobTicketReducer from 'app/stores/loadz/redux/JobsReport';
import JobAction from 'app/stores/loadz/redux/Jobs/actions';
import { LinearProgress } from '@material-ui/core';
import AuthAction from 'app/stores/loadz/redux/Auth/actions';
import { hasPermission } from 'app/main/loadz/utils';
import ErrorBoundary from 'app/main/ErrorBoundary';
import FuseLoading from '@fuse/core/FuseLoading/FuseLoading';
import client from 'client';
import CircularLoader from 'app/main/loadz/components/CircularLoader';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ButtonLog from 'app/main/ButtonLog';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import { TimelineOppositeContent } from '@mui/lab';
import { map } from 'lodash';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import ScaleImageDialog from './scaleImageDialog';
import { FileUploader } from 'react-drag-drop-files';
import { v4 as uuid } from 'uuid';
import { ScaleImageThumbnail } from '../ScaleImageThumbnail';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { formatter } from '../../../../constants';
import { resolveTicketAnchorDate } from '../buildManualTicketTime';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme?.palette?.common?.black,
    color: theme?.palette?.common?.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme?.palette?.action?.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const defaultValues = {
  reason: '',
};

const clearForm = {
  reason: '',
  tk_start: '',
  tk_end: '',
};

const TicketScaleImageUploader = ({ open, setOpen, handleAddEditScaleImage }) => {
  const { t } = useTranslation('navigation');
  const fileTypes = ['JPEG', 'PNG', 'JPG'];

  const onChange = async (file) => {
    let url = URL.createObjectURL(file);
    handleAddEditScaleImage(file);
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <FileUploader
        children={
          <div className='flex flex-col p-8'>
            <Box
              sx={{
                border: '5px dashed lightblue',
                borderRadius: 5,
                padding: 2,
                width: '500px',
              }}
            >
              <div className='flex flex-col gap-y-16 justify-center align-center items-center pb-32'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='172'
                  height='200'
                  viewBox='0 0 172 149'
                  fill='none'
                >
                  <g clip-path='url(#clip0_141_2095)'>
                    <path
                      d='M87.7472 54.6136C87.5441 54.3419 87.2804 54.1213 86.9771 53.9693C86.6738 53.8173 86.3392 53.7382 86 53.7382C85.6607 53.7382 85.3261 53.8173 85.0228 53.9693C84.7195 54.1213 84.4559 54.3419 84.2528 54.6136L56.3712 91.7765C56.1269 92.1003 55.9778 92.4858 55.9406 92.8897C55.9034 93.2936 55.9796 93.6998 56.1607 94.0628C56.3418 94.4257 56.6206 94.731 56.9657 94.9442C57.3109 95.1575 57.7086 95.2702 58.1143 95.2699H73.0645C73.6437 95.2699 74.1992 95.4993 74.6095 95.908C75.0198 96.3166 75.2514 96.8712 75.2535 97.4502V146.82C75.2525 147.107 75.3081 147.391 75.4172 147.657C75.5263 147.922 75.6868 148.163 75.8894 148.367C76.0921 148.57 76.3328 148.731 76.598 148.841C76.8631 148.951 77.1474 149.008 77.4345 149.008H94.5655C94.8526 149.008 95.1369 148.951 95.402 148.841C95.6671 148.731 95.9079 148.57 96.1105 148.367C96.3132 148.163 96.4736 147.922 96.5828 147.657C96.6919 147.391 96.7475 147.107 96.7464 146.82V97.4502C96.7486 96.8712 96.9802 96.3166 97.3904 95.908C97.8007 95.4993 98.3563 95.2699 98.9355 95.2699H113.886C114.291 95.2702 114.689 95.1575 115.034 94.9442C115.379 94.731 115.658 94.4257 115.839 94.0628C116.02 93.6998 116.097 93.2936 116.059 92.8897C116.022 92.4858 115.873 92.1003 115.629 91.7765L87.7472 54.6136Z'
                      fill='#BDBBBB'
                    />
                    <path
                      d='M154.188 51.412C153.089 50.6284 152.157 49.6333 151.447 48.4851C150.737 47.3369 150.263 46.0586 150.053 44.7251C148.278 32.8346 138.703 0 99.6814 0C79.0884 0 65.403 16.9482 62.5249 20.8388C62.1382 21.3625 61.6008 21.7556 60.9845 21.9654C60.4635 22.1457 59.904 22.1849 59.363 22.0789C54.612 21.1468 29.7545 13.3819 24.2009 43.2662C23.5359 46.5425 21.6452 49.4415 18.9148 51.3715C8.07509 59.2255 -0.00805664 71.8374 -0.00805664 85.9487C0.025205 96.2777 3.76391 106.252 10.5287 114.059C17.2934 121.866 26.6353 126.988 36.8566 128.494C38.2661 128.709 39.7033 128.355 40.852 127.511C42.0007 126.666 42.7668 125.4 42.9818 123.991C43.1968 122.582 42.8431 121.145 41.9985 119.997C41.1539 118.848 39.8876 118.082 38.4781 117.867C31.8555 116.94 25.6886 113.965 20.8401 109.361C15.9916 104.756 12.704 98.7518 11.4372 92.1873C10.1704 85.6227 10.9877 78.8265 13.7749 72.7493C16.5621 66.672 21.1797 61.6177 26.9817 58.2934C28.6711 57.3171 30.1297 55.9875 31.2575 54.3956C32.3853 52.8036 33.1558 50.9868 33.5163 49.0696C38.1538 23.3757 56.5416 33.5236 61.5276 36.8143C61.9113 37.0649 62.3422 37.2345 62.7937 37.3127C63.2453 37.3909 63.7081 37.376 64.1537 37.269C64.5994 37.162 65.0184 36.9651 65.3852 36.6904C65.752 36.4157 66.0588 36.069 66.2868 35.6715L69.6513 29.8032C76.5022 17.9046 88.6877 9.53995 102.122 10.7882C135.411 13.779 139.724 38.3462 139.935 49.5964C139.96 51.3522 140.437 53.0721 141.32 54.5898C142.203 56.1076 143.463 57.372 144.978 58.261V58.261C150.809 61.5727 155.454 66.6282 158.262 72.7166C161.069 78.8049 161.897 85.6199 160.629 92.2032C159.361 98.7864 156.061 104.807 151.193 109.418C146.325 114.028 140.133 116.998 133.49 117.908C132.08 118.123 130.814 118.889 129.969 120.037C129.125 121.186 128.771 122.622 128.986 124.032C129.201 125.441 129.967 126.707 131.116 127.551C132.264 128.395 133.702 128.749 135.111 128.534C143.577 127.349 151.494 123.657 157.842 117.933C164.19 112.21 168.678 104.717 170.728 96.4198C172.778 88.1231 172.295 79.4027 169.343 71.3824C166.391 63.3621 161.104 56.4094 154.164 51.4201L154.188 51.412Z'
                      fill='#BDBBBB'
                    />
                  </g>
                  <defs>
                    <clipPath id='clip0_141_2095'>
                      <rect width='172' height='149' fill='white' />
                    </clipPath>
                  </defs>
                </svg>
                &nbsp;
                <Typography className='text-18 font-bold'>
                  {t('DRAG_AND_DROP_FILES_HERE')}
                </Typography>
                <Typography className='text-14' color={'gray'}>
                  {t('OR')}
                </Typography>
                <div
                  className='flex w-3/5 justify-center align-center items-center'
                  style={{ border: '1px solid gray', padding: 6, cursor: 'pointer' }}
                >
                  <Typography className='text-16 font-bold' color={'blue'}>
                    {t('CLICK_HERE_TO_UPLOAD')}
                  </Typography>
                </div>
                <div
                  className='flex flex-col justify-center align-center items-center'
                  style={{ color: 'gray' }}
                >
                  <Typography className='text-14'>
                    {t('THESE_ARE_THE_ALLOWED_IMAGE_FORMAT')}:
                  </Typography>
                  <div>{fileTypes.join(', ')}</div>
                </div>
              </div>
            </Box>
          </div>
        }
        handleChange={onChange}
        name='file'
        types={fileTypes}
      />
    </Dialog>
  );
};

const isInvoiceEmailSent = (value) =>
  value === true || value === 1 || value === '1' || String(value).toLowerCase() === 'true';

const readInvoiceEmailSent = (...sources) =>
  sources.some((source) => {
    if (source == null || typeof source !== 'object') return false;
    return isInvoiceEmailSent(
      source.invoice_email_sent ?? source.invoice?.invoice_email_sent ?? source.invoice?.email_sent
    );
  });

const unwrapTicketGetPayload = (data) => {
  if (data == null) return { ticket: null, extra: null };
  if (Array.isArray(data)) return { ticket: data[0] || null, extra: data[0] || null };
  if (typeof data !== 'object') return { ticket: null, extra: null };
  if (Array.isArray(data.tickets)) {
    return { ticket: data.tickets[0] || null, extra: data };
  }
  if (Array.isArray(data.data)) {
    return { ticket: data.data[0] || null, extra: data };
  }
  if (data.ticket && typeof data.ticket === 'object') {
    return { ticket: data.ticket, extra: data };
  }
  if (data.data && typeof data.data === 'object') {
    return unwrapTicketGetPayload(data.data);
  }
  return { ticket: data, extra: data };
};

const extractTicketInvoice = (ticket, extra = null) => {
  if (!ticket || typeof ticket !== 'object') return null;
  const nestedInvoice = ticket.invoice && typeof ticket.invoice === 'object' ? ticket.invoice : null;
  const invoiceId =
    ticket.invoice_id ?? ticket.invoiceId ?? ticket.inv_id ?? nestedInvoice?.invoice_id ?? nestedInvoice?.id;
  const invoiceNoRaw =
    ticket.invoice_no ??
    ticket.invoice_number ??
    (typeof ticket.invoice === 'string' ? ticket.invoice : null) ??
    nestedInvoice?.invoice_no ??
    nestedInvoice?.invoice;
  const hasId =
    invoiceId != null &&
    invoiceId !== '' &&
    String(invoiceId) !== '0' &&
    String(invoiceId).toLowerCase() !== 'null';
  const hasNo =
    invoiceNoRaw != null &&
    String(invoiceNoRaw).trim() !== '' &&
    String(invoiceNoRaw).toLowerCase() !== 'null';
  const invoiceEmailSent = readInvoiceEmailSent(ticket, extra, nestedInvoice);
  if (!hasId && !hasNo && !invoiceEmailSent) return null;
  return {
    invoice_id: invoiceId,
    invoice_no: hasNo ? String(invoiceNoRaw) : hasId ? String(invoiceId) : '—',
    invoice_email_sent: invoiceEmailSent,
  };
};

function formatWaitRateForInput(value) {
  if (value == null || value === '') return '';
  const raw = String(value).replace(/[$,]/g, '').trim();
  if (!Number.isFinite(Number(raw))) return '';
  if (!raw.includes('.')) return String(Number(raw));
  return raw.replace(/0+$/, '').replace(/\.$/, '');
}

function waitIntervalHours(start, end) {
  const startAt = moment(start);
  const endAt = moment(end);
  if (!startAt.isValid() || !endAt.isValid() || !endAt.isAfter(startAt)) return 0;
  return endAt.diff(startAt, 'minutes') / 60;
}

function previewWaitCost(starts, ends, rate) {
  const hourly = Number(String(rate ?? '').replace(/[$,]/g, ''));
  if (!Number.isFinite(hourly) || hourly < 0) return null;
  const count = Math.min(Array.isArray(starts) ? starts.length : 0, Array.isArray(ends) ? ends.length : 0);
  let hours = 0;
  for (let i = 0; i < count; i += 1) {
    hours += waitIntervalHours(starts[i], ends[i]);
  }
  return Math.round(hours * hourly * 100) / 100;
}

function parseMoneyAmount(value) {
  const amount = Number(String(value ?? '').replace(/[$,%\s]/g, ''));
  return Number.isFinite(amount) ? amount : 0;
}

/** Portion of wait cost that is included in the driver commission. */
function driverWaitCommission(waitCost, payPercent) {
  return Math.round(parseMoneyAmount(waitCost) * (parseMoneyAmount(payPercent) / 100) * 100) / 100;
}

/** Employee cost without the wait-time commission already included in the stored total. */
function employeeCostExcludingWait(employeeCost, waitCost, payPercent) {
  const base = Math.round((parseMoneyAmount(employeeCost) - driverWaitCommission(waitCost, payPercent)) * 100) / 100;
  return base > 0 ? base : 0;
}

function activeWaitCost(starts, ends, rate, savedCost, deletedIndexes) {
  const deleted = new Set(deletedIndexes || []);
  const count = Math.min(Array.isArray(starts) ? starts.length : 0, Array.isArray(ends) ? ends.length : 0);
  if (count === 0) return parseMoneyAmount(savedCost);
  const activeStarts = [];
  const activeEnds = [];
  for (let i = 0; i < count; i += 1) {
    if (!deleted.has(i)) {
      activeStarts.push(starts[i]);
      activeEnds.push(ends[i]);
    }
  }
  if (activeStarts.length === 0) return 0;
  if (deleted.size === 0) return parseMoneyAmount(savedCost);
  const preview = previewWaitCost(activeStarts, activeEnds, rate);
  return preview == null ? 0 : preview;
}

const getTicketInvoiceStatus = async (tkId, companyAcct) => {
  try {
    const result = await client.post('/ticket/get', {
      tickets: [tkId],
      comp_acct: companyAcct,
      compacctnum: companyAcct,
    });
    const { ticket, extra } = unwrapTicketGetPayload(result?.data);
    return extractTicketInvoice(ticket, extra);
  } catch (error) {
    console.error('Error checking ticket invoice:', error);
    return null;
  }
};

function TicketsTable({
  ticketStatus,
  getAllTicketJobs,
  hasNextPage,
  searchJobTickets,
  loading,
  getAllJobs,
  hasNextJob,
  transferJobTickets,
  jobs,
  jobPage,
  page,
  jobTickets,
  jdestination,
  search,
  quarrypit,
  getDrivers,
  getTrucks,
  trucks,
  drivers,
  deleteJobTickets,
  editJobTicket,
  user,
  logout,
  searchJobs,
  data,
  job_id,
  onSearchDate,
  date1,
  date2,
  ticketSearch,
}) {
  const { t, i18n } = useTranslation('navigation');
  const { notifyPastDue } = useSubscriptionPaywall();
  const prop_data = data;
  const { id } = useParams();
  //console.log(id);
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = React.useState(false);
  const [ticketPop, setTicketPop] = React.useState(null);
  const [compLogo, setCompLogo] = useState(null);
  const [selected, setSelected] = useState([]);
  const [tk_id, setDelete] = useState(0);
  const [tk_No, settkNo] = useState(0);
  const [tkstartFinal, setTkStart] = useState([]);
  const [tkendFinal, setTkEnd] = useState([]);
  const [tkwaitstart, setTkwaitstart] = useState([]); //
  const [tkwaitend, setTkwaitend] = useState([]);
  const [companyWaitRate, setCompanyWaitRate] = useState(null);
  const [timeend, setTimeEnd] = useState(null);
  const [timestart, setTimeStart] = useState(null);
  const [waittimeend, setWaitTimeEnd] = useState(null);
  const [waittimestart, setWaitTimeStart] = useState(null);
  const [sendEmails, setSendEmails] = useState(false);
  const [leaveTkAlone, setLeaveTkAlone] = useState(true);
  const [singleInvoice, setSingleInvoice] = useState(false);
  const [insertInvoice, setInsertInvoice] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const history = useHistory();
  const [showImageLoader] = useState(true);
  const token = localStorage.token;
  const listInnerRef = useRef();
  // const estatus = 1;
  const [open, setOpen] = useState(false);
  const [openedit, setOpenEdit] = useState(false);
  const [allJobs, setAllJobs] = useState([]);
  const componentRef = useRef();
  const [jobTransfer, setJobTransfer] = useState(false);
  const [zeroInvoiceConfirm, setZeroInvoiceConfirm] = useState({
    open: false,
    invoice_no: null,
    message: '',
    payload: null,
  });
  const [invoiceEditConfirm, setInvoiceEditConfirm] = useState({
    open: false,
    invoice_no: null,
  });
  const [newticketjob, setNewTicketJob] = useState();
  const [scrollX, setScrollX] = useState(0);
  const comp_acct = prop_data ? prop_data.compacctnum : user.company.compacctnum;
  const [isOpen, setIsOpen] = useState(false);
  const [scaleImage, setScaleImage] = useState('');
  // const logoUrl = store.getState().photo ? store.getState().photo : user?.company?.logo
  const [logoUrl, setLogoUrl] = useState(null);

  const [tickettype, setTicketType] = useState('');
  const compacctnum = prop_data ? prop_data.compacctnum : user?.company?.compacctnum;

  const [openreq_edit, setopenreq_edit] = useState(false);
  const [openreq_delete, setopenreq_delete] = useState(false);
  const [openreq_transfer, setopenreq_transfer] = useState(false);
  const [req_reason, setreq_reason] = useState('');
  const [transfersearch, setTransferSearch] = useState('');
  const [truckDriverLoading, setTruckDriverLoading] = useState(false);
  const [loadingBar, setLoadingBar] = useState(false);
  const GET_PRE_SIGNED_URL = '/aws/pre-signed-url';

  const [currentLocation, setCurrentLocation] = useState();

  const getCurrentLatLong = () => {
    try {
      if (navigator.geolocation) {
        // If geolocation is supported, get the current position
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setCurrentLocation({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            });
          },
          (error) => {
            // Error callback - if something goes wrong
            console.error('Error occurred while retrieving geolocation:', error);
          }
        );
      } else {
        console.log('Geolocation is not supported by this browser.');
      }
    } catch (error) {
      console.log('Geolocation is not supported by this browser.');
    }
  };

  useEffect(() => {
    getCurrentLatLong();
  }, []);

  const download = (name, e) => {
    //console.log(e);
    fetch(e, {
      method: 'GET',
      headers: {},
    })
      .then((response) => {
        response.arrayBuffer().then(function (buffer) {
          const url = window.URL.createObjectURL(new Blob([buffer]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', name + '.png'); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
      })
      .catch((err) => {
        //console.log(err);
      });
  };

  useEffect(() => {
    let key = prop_data ? prop_data?.logo : user?.company?.logo;
    if (key.includes('http')) {
      setLogoUrl(key);
    } else {
      setLogoUrl(`${constants.URLLOCAL}/aws/signed?image=${key}`);
    }
  }, [prop_data?.logo, user?.company?.logo]);

  //const [newticketjob, setNewTicketJob] = useState()
  const _showMessage = (msg, color) => {
    dispatch(
      showMessage({
        message: (
          <>
            <Typography>{msg}</Typography>
          </>
        ), //text or html
        autoHideDuration: 6000, //ms

        anchorOrigin: {
          vertical: 'top', //top bottom
          horizontal: 'right', //left center right
        },
        variant: color, //success error info warning null
      })
    );
  };

  let setjDestion = {
    jobDesination: jdestination && jdestination ? jdestination : null,
    jobQryPit: quarrypit && quarrypit ? quarrypit : null,
  };

  const { control, reset, setValue, getValues, watch } = useForm({
    mode: 'all',
    reValidateMode: 'onChange',
    defaultValues,
  });
  const watchedWaitCr = watch('wait_cr');
  const watchedTkPay = watch('tk_pay');
  const watchedWaitRate = watch('tk_wait_rate');

  const getS3Location = async (key) => {
    if (key != null && key != '') {
      let data = {
        key: prop_data ? prop_data?.logo : user?.company?.logo,
      };
      return await getDataFromS3(data);
    }
  };
  function diff(start, end) {
    //I can add the clock in and clock out dates
    start = start.split(':');
    end = end.split(':');
    var startDate = new Date(0, 0, 0, start[0], start[1], 0);
    var endDate = new Date(0, 0, 0, end[0], end[1], 0);
    var diff = endDate.getTime() - startDate.getTime();
    var hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    var minutes = Math.floor(diff / 1000 / 60);

    // 24 hours format
    if (hours < 0) hours = hours + 24;

    return (hours <= 9 ? '0' : '') + hours + ':' + (minutes <= 9 ? '0' : '') + minutes;
  }

  //function to put together a string from an array ['foo','bar'] = foobar
  function glue(pieces) {
    //glue the split back together
    return pieces[0] + ':' + pieces[1];
  }
  function getTimeDuration(timeData) {
    if (
      timeData &&
      timeData.tk_wait_start &&
      timeData.tk_wait_start.length > 0 &&
      timeData.tk_wait_end &&
      timeData.tk_wait_end.length > 0
    ) {
      try {
        //console.log('WAIT TIMES > ', timeData);
        let total_hours = 0;
        let total_minutes = 0;
        if (timeData.tk_wait_start.length == timeData.tk_wait_end.length) {
          for (let i = 0; i < timeData.tk_wait_start.length; i++) {
            var start_time =
              moment.tz(timeData.tk_wait_start[i], moment.tz.guess(true)).format('HH:mm') ==
              'Invalid date'
                ? moment
                    .tz(
                      `${moment().format('YYYY-MM-DD')} ` + timeData.tk_wait_start[i],
                      moment.tz.guess(true)
                    )
                    .format('HH:mm:ss')
                : moment.tz(timeData.tk_wait_start[i], moment.tz.guess(true)).format('HH:mm:ss');
            var end_time =
              moment.tz(timeData.tk_wait_end[i], moment.tz.guess(true)).format('HH:mm') ==
              'Invalid date'
                ? moment
                    .tz(
                      `${moment().format('YYYY-MM-DD')} ` + timeData.tk_wait_end[i],
                      moment.tz.guess(true)
                    )
                    .format('HH:mm:ss')
                : moment.tz(timeData.tk_wait_end[i], moment.tz.guess(true)).format('HH:mm:ss');
            var time_diff = diff(start_time, end_time);
            time_diff = time_diff.split(':');
            //console.log(time_diff);

            const hours = +time_diff[0];
            const minutes = +time_diff[1];
            //console.log(hours);
            //console.log(minutes);
            if (hours) total_hours = total_hours + hours;
            if (minutes) total_minutes = total_minutes + minutes;
          }
        }
        while (total_minutes >= 60) {
          total_minutes = total_minutes - 60;
          total_hours = total_hours + 1;
        }
        let tkTime = total_hours + ' Hours ' + total_minutes + ' Minutes';
        return tkTime;
      } catch (error) {
        return null;
      }
    } else {
      return null;
    }
  }

  function getTkStartEndTime(startEndTime) {
    if (startEndTime && startEndTime.tk_start && startEndTime.tk_end) {
      try {
        let total_hours = 0;
        let total_minutes = 0;
        for (let i = 0; i < startEndTime.tk_start.length; i++) {
          //console.log('TIMES ', startEndTime.tk_start[i], startEndTime.tk_end[i]);
          const tkStart =
            moment.tz(startEndTime.tk_start[i], moment.tz.guess(true)).format('HH:mm:ss') ==
            'Invalid date'
              ? moment
                  .tz(
                    `${moment().format('YYYY-MM-DD')} ` + startEndTime.tk_start[i],
                    moment.tz.guess(true)
                  )
                  .format('HH:mm:ss')
              : moment.tz(startEndTime.tk_start[i], moment.tz.guess(true)).format('HH:mm:ss');
          const tkEnd =
            moment.tz(startEndTime.tk_end[i], moment.tz.guess(true)).format('HH:mm:ss') ==
            'Invalid date'
              ? moment
                  .tz(
                    `${moment().format('YYYY-MM-DD')} ` + startEndTime.tk_end[i],
                    moment.tz.guess(true)
                  )
                  .format('HH:mm:ss')
              : moment.tz(startEndTime.tk_end[i], moment.tz.guess(true)).format('HH:mm:ss');
          //console.log('tkStart,tkEnd', tkStart, tkEnd);
          var time_diff = diff(tkStart, tkEnd);
          //console.log('time_diff', time_diff);
          time_diff = time_diff.split(':');

          const hours = +time_diff[0];
          const minutes = +time_diff[1];
          if (hours) total_hours = total_hours + hours;
          if (minutes) total_minutes = total_minutes + minutes;
        }

        while (total_minutes >= 60) {
          total_minutes = total_minutes - 60;
          total_hours = total_hours + 1;
        }
        let tkTime = total_hours + ' Hours ' + total_minutes + ' Minutes';
        return tkTime;
      } catch (err) {
        //console.log(err.message);
        return null;
      }
    } else {
      return null;
    }
  }
  // function getTkStartEndTime(startEndTime) {
  //   if (startEndTime && startEndTime.tk_start && startEndTime.tk_end) {
  //     try {
  //       const tkStart = moment(startEndTime.tk_start, 'HH:mm:ss')
  //       const tkEnd = moment(startEndTime.tk_end, 'HH:mm:ss')
  //       const duration = moment.duration(tkEnd.diff(tkStart))
  //       const hours = parseInt(duration.asHours())
  //       const minutes = parseInt(duration.asMinutes()) % 60
  //       let tkTime = hours + ' Hours ' + minutes + ' Minutes'
  //       return tkTime
  //     } catch (err) {
  //       return null
  //     }
  //   } else {
  //     return null
  //   }
  // }

  const [deleteTicketLoading, setDeleteTicketLoading] = useState(false);
  const [updateTicketLoading, setUpdateTicketLoading] = useState(false);
  const deleteTicket = async () => {
    setDeleteTicketLoading(true);
    const reason = getValues('reason');
    await deleteJobTickets(
      {
        tk_id,
        reason,
        is_op: tickettype == 'OP' ? true : false,
        send_emails: sendEmails,
        user_id: user?.staff ? user?.staff?.staff_u_id : user?.user_id,
      },
      async (result) => {
        //console.log('RESULT ON SUCCESS', result)
        if (result?.data?.err_message) {
          _showMessage(result?.data?.err_message, 'error');
        } else if (result?.data == true) {
          _showMessage(t('TICKET_DELETED'), 'success');
        }

        await getAllTicketJobs(
          {
            page: 1,
            data: {
              id: job_id ? job_id : id,
              estatus: ticketStatus,
              compacctnum: prop_data ? prop_data?.compacctnum : user.company.compacctnum,
            },
          },
          (e) => {
            //console.log(e);
          }
        );

        setDeleteTicketLoading(false);
      },
      (error) => {
        //console.log(error);
        _showMessage(t('ERROR'), 'error');
        setDeleteTicketLoading(false);
      }
    );
    reset(clearForm);
    handleClose();
  };

  const open_reqdelete = async (n) => {
    //let {id, compacctnum, request_info, type, date} = info
    setopenreq_delete(true);
    setDelete(n.tk_id);
  };
  const req_delete_ticket = async () => {
    await client.post(`/requests/`, {
      id: prop_data
        ? prop_data.id
        : user?.company?.staff_id == '0'
        ? user.user_id
        : user?.company?.staff_id,
      compacctnum: comp_acct,
      request_info: tk_id,
      type: 'clone ticket delete',
      date: moment().format('YYYY-MM-DD'),
      time: moment().format('HH:mm'),
      reason: req_reason,
    });
    setreq_reason('');
    setopenreq_delete(false);
    _showMessage(t('REQUEST_CREATED'), 'success');
  };

  const open_reqedit = async (n) => {
    //let {id, compacctnum, request_info, type, date} = info
    console.log('open_reqedit', n);
    setopenreq_edit(true);
    setDelete(n.tk_id);
  };
  const req_edit_ticket = async () => {
    if (req_reason.length <= 0) {
      return _showMessage(t('PLEASE_ENTER_THE_DETAILS_FOR_THE_EDIT'), 'warning');
    } else {
      await client.post(`/requests/`, {
        id: prop_data
          ? prop_data.id
          : user?.company?.staff_id == '0'
          ? user?.id
          : user?.company?.staff_id,
        compacctnum: comp_acct,
        request_info: tk_id,
        type: 'clone ticket edit',
        date: moment().format('YYYY-MM-DD'),
        time: moment().format('HH:mm'),
        reason: req_reason,
      });
      setreq_reason('');
      setopenreq_edit(false);
      _showMessage(t('REQUEST_CREATED'), 'success');
    }
  };

  const open_reqtransfer = async (n) => {
    //let {id, compacctnum, request_info, type, date} = info
    setopenreq_transfer(true);
    setDelete(n.tk_id);
  };
  const req_transfer_ticket = async () => {
    //
    if (newticketjob == null || newticketjob == undefined) {
      return _showMessage(t('PLEASE_SELECT_A_VALID_JOB'), 'error');
    } else {
      await client.post(`/requests/`, {
        id: prop_data
          ? prop_data.id
          : user?.company?.staff_id == '0'
          ? user?.user_id
          : user?.company?.staff_id,
        compacctnum: comp_acct,
        request_info: tk_id,
        type: 'clone ticket transfer',
        date: moment().format('YYYY-MM-DD'),
        time: moment().format('HH:mm'),
        reason: req_reason,
        job_id: newticketjob.job_id,
      });
      setreq_reason('');
      setopenreq_transfer(false);
      _showMessage(t('REQUEST_CREATED'), 'success');
    }
  };

  async function editTicket(options = {}) {
    if (updateTicketLoading) return;
    const skipInvoiceConfirm = options.skipInvoiceConfirm === true;

    const {
      tk_qty: qty,
      tk_scale_no: scale_no,
      tk_datecreated,
      tk_wait_start,
      tk_wait_end,
      truck_id,
      tk_status,
      tk_job_no,
      driver_id,
      tk_start,
      tk_end,
      tk_rate,
      tk_cost,
      tk_mat_rate,
      tk_mat_cost,
      tk_wait_rate,
      tk_pay,
    } = getValues();

    const jobScale = jobTickets[0].scale;

    const { messageFlag, warningFields } = await ValidateNumericFields(
      qty,
      tk_rate,
      tk_cost,
      tk_mat_rate,
      tk_mat_cost,
      scale_no,
      jobScale,
      t
    );

    if (messageFlag) {
      const warningFieldsString = warningFields.length > 0 ? ' ' + warningFields.join(', ') : '';
      _showMessage(
        `${t(
          'ONLY_NUMBER_AND_A_DECIMAL_ARE_ALLOWED_PLEASE_REVIEW_THE_FOLLOWINGS_FIELDS'
        )} ${warningFieldsString}`,
        'error'
      );
      return;
    }

    if (!skipInvoiceConfirm) {
      // Validación: Hauling Cost Rate mayor que Hauling Invoice Rate
      const haulingCost = parseFloat(tk_cost);
      const haulingRate = parseFloat(tk_rate);
      if (!isNaN(haulingCost) && !isNaN(haulingRate) && haulingCost > haulingRate) {
        const diff = (haulingCost - haulingRate).toFixed(2);
        const msg = `${t('EDIT_TICKET_HAULING_COST_RATE_WARNING_MESSAGE_1')}${haulingCost}? ${t(
          'EDIT_TICKET_HAULING_COST_RATE_WARNING_MESSAGE_2'
        )}${diff}.`;
        if (!window.confirm(msg)) {
          _showMessage('Update cancelled.', 'warning');
          return;
        }
      }

      const fromApi = await getTicketInvoiceStatus(tk_id, compacctnum);
      const fromEditing = extractTicketInvoice(editingTicket);
      const invoiceInfo = fromApi || fromEditing
        ? {
            invoice_id: fromApi?.invoice_id ?? fromEditing?.invoice_id,
            invoice_no: fromApi?.invoice_no || fromEditing?.invoice_no || '—',
            invoice_email_sent: Boolean(
              fromApi?.invoice_email_sent || fromEditing?.invoice_email_sent
            ),
          }
        : null;
      if (invoiceInfo?.invoice_email_sent) {
        setInvoiceEditConfirm({
          open: true,
          invoice_no: invoiceInfo.invoice_no || '—',
        });
        return;
      }
    }

    setUpdateTicketLoading(true);

    const data = {
      tk_id,
      qty,
      scale_no,
      tk_datecreated: toTicketCalendarDateTime(tk_datecreated),
      truck_id: tickettype == 'EMP' ? truck_id : null,
      tk_status,
      tk_job_no,
      driver_id: tickettype == 'EMP' ? driver_id : null,
      is_op: tickettype == 'OP' ? true : false,
      send_emails: skipInvoiceConfirm ? Boolean(options.send_emails) : sendEmails,
      tk_rate,
      tk_cost,
      tk_mat_rate,
      tk_mat_cost,
      tk_wait_rate,
      tk_pay,
    };

    data.tk_wait_start =
      Array.isArray(tk_wait_start) && tk_wait_start.length > 0 ? tk_wait_start : null;
    data.tk_wait_end = Array.isArray(tk_wait_end) && tk_wait_end.length > 0 ? tk_wait_end : null;
    data.tk_start = tk_start ? tk_start : null;
    data.tk_end = tk_end ? tk_end : null;

    const comp_acct = prop_data ? prop_data.compacctnum : user?.company?.compacctnum;
    data.comp_acct = comp_acct;

    data.user_id = prop_data
      ? prop_data.compacctnum
      : user?.staff
      ? user?.staff?.staff_u_id
      : user?.user_id;
    // data.scale_ticket_image = editTkScaleImage
    //console.log('deleteWaitTime',deleteWaitTime)
    data.deleteWaitTime = deleteWaitTime; //contains index of wait time to delete

    if (recalcWith && String(recalcWith).startsWith('job_')) {
      const entryId = parseInt(String(recalcWith).replace('job_', ''), 10);
      if (!isNaN(entryId)) data.recalc_with_job_entry_id = entryId;
    }

    const _scaleImage = [];
    const _scaleImageTimeStamp = [];

    try {
      for (const scaleImage of editTkScaleImage) {
        if (scaleImage?.file) {
          const params = { key: uuid(), bucketType: 'tickets', user_id: user?.user_id };
          const result = await client.post(GET_PRE_SIGNED_URL, params);
          if (result?.data?.key) {
            ////console.log(result?.data?.url);

            // Upload the file to the generated URL
            const uploadResult = await client.put(result.data.url, scaleImage?.file);

            if (uploadResult?.status === 200) {
              _scaleImageTimeStamp.push({
                timestamp: moment.utc().format(),
                key: result.data.key,
              });
              _scaleImage.push(result.data.key);
            }
          }
        } else {
          //console.log(scaleImage)
          const { key, timestamp } = scaleImage;
          _scaleImage.push(key);
          _scaleImageTimeStamp.push({ key, timestamp });
        }
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      _showMessage(t('FAILED_TO_UPLOAD_SCALE_IMAGE_MESSAGE'));
      setUpdateTicketLoading(false);
      return;
    }
    data.scale_ticket_image = _scaleImage;
    data.scale_image_timestamp = JSON.stringify(_scaleImageTimeStamp);

    try {
      ButtonLog({
        type: 'ticket',
        info: `${JSON.stringify(data)}`,
        button_name: `ticket_edit`,
      });

      if (currentLocation?.latitude && currentLocation?.longitude) {
        data.latitude = currentLocation?.latitude;
        data.longitude = currentLocation?.longitude;
      }
      // Ticket edit (scale images / emails) can exceed the default 30s client timeout
      const editResult = await client.post('/ticket/edit', data, { timeout: 0 });
      const result = editResult?.data;

      if (result?.err_message) {
        _showMessage(`${result.err_message}`, 'error');
        setSendEmails(false);
        return;
      }

      if (result?.message) {
        _showMessage(`${result.message}`, 'success');
        setSendEmails(false);
      }

      if (result?.confirmation) {
        _showMessage(
          `${t('THE_TICKET_WITH_THE_NUMBER')} ${result.tk_no} ${t(
            'HAS_BEEN_EDITED_CORRECTLY'
          )}`,
          'success'
        );
        setSendEmails(false);
      }

      // Keep the loading overlay until the table has the saved values; reopening a stale row
      // shows old rates and saving it again reverts the edit.
      await new Promise((resolve) => {
        const timer = setTimeout(resolve, 30000);
        const finish = () => {
          clearTimeout(timer);
          resolve();
        };
        if (search && search.length > 2) {
          searchJobTickets(
            {
              id: job_id ? job_id : id,
              searchText: search,
              accountNumber: compacctnum,
              selectedTab: ticketStatus,
            },
            finish,
            finish
          );
        } else {
          getAllTicketJobs(
            {
              page: 1,
              data: {
                id: job_id ? job_id : id,
                estatus: ticketStatus,
                compacctnum: prop_data ? prop_data?.compacctnum : user.company.compacctnum,
              },
            },
            finish,
            finish
          );
        }
      });

      handleCloseEdit();
      setTimeStart(null);
      setTimeEnd(null);
      setEditTkScaleImage([]);
      reset(clearForm);
      setDeleteWaitTime([]);
    } catch (error) {
      console.error('Error updating ticket:', error);
      _showMessage(`${error}`, 'error');
    } finally {
      setUpdateTicketLoading(false);
    }
  }

  async function loadValuesFromChange(auditId) {
    if (!editingTicket?.tk_id || !auditId) return;
    setRecalcLoading(true);
    try {
      const result = await client.post('/ticket/values-from-change', {
        tk_id: editingTicket.tk_id,
        ticket_audit_id: auditId,
      });
      if (result?.data?.err_message) {
        _showMessage(result.data.err_message, 'error');
        return;
      }
      const data = result?.data;
      if (data?.ticket_cr != null) setValue('ticket_cr', data.ticket_cr);
      if (data?.material_cr != null) setValue('material_cr', data.material_cr);
      if (data?.wait_cr != null) setValue('wait_cr', data.wait_cr);
      if (data?.tk_qty != null) setValue('tk_qty', data.tk_qty);
      if (data?.tk_rate != null) setValue('tk_rate', data.tk_rate);
      if (data?.tk_mat_rate != null) setValue('tk_mat_rate', data.tk_mat_rate);
      _showMessage('Values loaded from selected change', 'success');
    } catch (e) {
      _showMessage(e?.message || 'Error loading values from change', 'error');
    } finally {
      setRecalcLoading(false);
    }
  }

  function applyCorrectionValuesToForm(preview, { showToast = false } = {}) {
    if (!preview?.proposed || !(preview.changes || []).length) return;
    const p = preview.proposed;
    const changed = new Set((preview.changes || []).map((c) => c.field));
    const snapshot = {};

    if (changed.has('tk_qty') && p.tk_qty != null) {
      snapshot.tk_qty = getValues('tk_qty');
      setValue('tk_qty', p.tk_qty);
    }
    if (changed.has('tk_rate') && p.tk_rate != null) {
      snapshot.tk_rate = getValues('tk_rate');
      setValue('tk_rate', p.tk_rate);
    }
    if (changed.has('tk_cost') && p.tk_cost != null) {
      snapshot.tk_cost = getValues('tk_cost');
      setValue('tk_cost', p.tk_cost);
    }
    if (changed.has('ticket_cr') && p.ticket_cr != null) {
      snapshot.ticket_cr = getValues('ticket_cr');
      const cr =
        typeof p.ticket_cr === 'number'
          ? `$${Number(p.ticket_cr).toFixed(2)}`
          : p.ticket_cr;
      setValue('ticket_cr', cr);
    }
    if (changed.has('tk_cost') && p.hauling_cost != null) {
      snapshot.hauling_cost = getValues('hauling_cost');
      setValue(
        'hauling_cost',
        `$${Number(p.hauling_cost).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      );
    }

    setLastEditRevertSnapshot(snapshot);
    setLastEditBannerVisible(true);
    if (showToast) {
      _showMessage(
        i18n.language === 'es'
          ? 'Valores cargados en el formulario. Revise y pulse Update para guardar.'
          : 'Values loaded into the form. Review and click Update to save.',
        'success'
      );
    }
  }

  function dismissLastEditCorrection() {
    if (lastEditRevertSnapshot) {
      Object.entries(lastEditRevertSnapshot).forEach(([key, value]) => {
        setValue(key, value);
      });
    }
    setLastEditBannerVisible(false);
    setLastEditRevertSnapshot(null);
    setLastEditPreview((prev) =>
      prev
        ? {
            ...prev,
            needs_correction: false,
            changes: [],
          }
        : null
    );
    setLastEditPreviewOpen(false);
  }

  async function fetchLastEditCorrection(tkId, { openDialog = false, autoApply = false } = {}) {
    if (!tkId) return;
    setLastEditPreviewLoading(true);
    if (openDialog) {
      setLastEditPreviewOpen(true);
    }
    try {
      const result = await client.post('/ticket/preview-last-edit-correction', { tk_id: tkId });
      if (result?.data?.err_message) {
        if (openDialog) {
          _showMessage(result.data.err_message, 'error');
          setLastEditPreviewOpen(false);
        }
        setLastEditPreview(null);
        setLastEditBannerVisible(false);
        return;
      }
      const preview =
        result?.data?.corrections?.[0] ||
        result?.data?.needing_correction?.[0] ||
        null;
      setLastEditPreview(preview);
      if (
        autoApply &&
        preview?.needs_correction &&
        (preview.changes || []).length > 0
      ) {
        applyCorrectionValuesToForm(preview, { showToast: false });
      } else if (!preview?.needs_correction) {
        setLastEditBannerVisible(false);
        setLastEditRevertSnapshot(null);
      }
    } catch (e) {
      if (openDialog) {
        _showMessage(
          e?.message ||
            (i18n.language === 'es'
              ? 'Error al obtener la última edición'
              : 'Error loading last edit correction'),
          'error'
        );
        setLastEditPreviewOpen(false);
      }
      setLastEditPreview(null);
      setLastEditBannerVisible(false);
    } finally {
      setLastEditPreviewLoading(false);
    }
  }

  async function openLastEditCorrectionPreview() {
    const tkId = editingTicket?.tk_id || tk_id;
    if (!tkId) return;
    if (lastEditPreview) {
      setLastEditPreviewOpen(true);
      return;
    }
    await fetchLastEditCorrection(tkId, { openDialog: true, autoApply: false });
  }

  function applyLastEditPreviewToForm() {
    if (!lastEditPreview) return;
    applyCorrectionValuesToForm(lastEditPreview, { showToast: true });
    setLastEditPreviewOpen(false);
  }

  async function handleRecalcValues(optionValue, opts = {}) {
    const tkId = opts.tk_id ?? editingTicket?.tk_id;
    const current = optionValue != null ? optionValue : recalcWith;
    const isJobEntry = typeof current === 'string' && current.startsWith('job_');
    if (isJobEntry) {
      const entryId = parseInt(String(current).replace('job_', ''), 10);
      if (!tkId) return;
      setRecalcLoading(true);
      try {
        const result = await client.post('/ticket/recalc-values', {
          tk_id: tkId,
          recalc_with: 'job_entry',
          job_billing_entry_id: entryId,
          comp_acct: prop_data ? prop_data.compacctnum : user?.company?.compacctnum,
          tk_qty: getValues('tk_qty'),
        });
        if (result?.data?.err_message) {
          _showMessage(result.data.err_message, 'error');
          return;
        }
        const data = result?.data;
        const setOpts = { shouldDirty: true, shouldTouch: true };
        if (data?.ticket_cr != null) setValue('ticket_cr', data.ticket_cr, setOpts);
        if (data?.material_cr != null) setValue('material_cr', data.material_cr, setOpts);
        if (data?.wait_cr != null) setValue('wait_cr', data.wait_cr, setOpts);
        if (data?.tk_qty != null) setValue('tk_qty', data.tk_qty, setOpts);
        if (data?.tk_rate != null && data?.tk_rate !== undefined) setValue('tk_rate', data.tk_rate, setOpts);
        if (data?.tk_cost != null && data?.tk_cost !== undefined) setValue('tk_cost', data.tk_cost, setOpts);
        if (data?.tk_mat_rate != null && data?.tk_mat_rate !== undefined) setValue('tk_mat_rate', data.tk_mat_rate, setOpts);
        if (data?.tk_mat_cost != null && data?.tk_mat_cost !== undefined) setValue('tk_mat_cost', data.tk_mat_cost, setOpts);
        // Do not show success toast on dropdown selection; values update silently.
      } catch (e) {
        _showMessage(e?.message || (i18n.language === 'es' ? 'Error al recalcular valores' : 'Error recalculating values'), 'error');
      } finally {
        setRecalcLoading(false);
      }
      return;
    }
    if (!tkId) return;
    const comp_acct = prop_data ? prop_data.compacctnum : user?.company?.compacctnum;
    const payload = {
      tk_id: tkId,
      recalc_with: recalcWith,
      comp_acct,
    };
    if (recalcWith === 'new') {
      const vals = getValues();
      payload.tk_qty = vals.tk_qty;
      payload.tk_rate = vals.tk_rate;
      payload.tk_mat_rate = vals.tk_mat_rate;
      payload.tk_wait_rate = vals.tk_wait_rate;
      if (vals.tk_wait_start && vals.tk_wait_end) {
        payload.tk_wait_start = vals.tk_wait_start;
        payload.tk_wait_end = vals.tk_wait_end;
      }
    }
    setRecalcLoading(true);
    try {
      const result = await client.post('/ticket/recalc-values', payload);
      if (result?.data?.err_message) {
        _showMessage(result.data.err_message, 'error');
        return;
      }
      const data = result?.data;
      if (data?.ticket_cr != null) setValue('ticket_cr', data.ticket_cr);
      if (data?.material_cr != null) setValue('material_cr', data.material_cr);
      if (data?.wait_cr != null) setValue('wait_cr', data.wait_cr);
      if (data?.tk_qty != null) setValue('tk_qty', data.tk_qty);
      _showMessage(
        i18n.language === 'es' ? 'Valores recalculados correctamente' : 'Values recalculated successfully',
        'success'
      );
    } catch (e) {
      _showMessage(e?.message || (i18n.language === 'es' ? 'Error al recalcular valores' : 'Error recalculating values'), 'error');
    } finally {
      setRecalcLoading(false);
    }
  }

  function handleRecalcOptionChange(value) {
    setRecalcWith(value);
    const isJobEntry = typeof value === 'string' && value.startsWith('job_');
    if (isJobEntry) {
      handleRecalcValues(value);
    }
  }

  async function getScaleImage(data) {
    setIsOpen(true);
    setScaleImage(data);
  }
  async function getSingleTicketData(data) {
    console.log('getSingleTicketData => ', data);
    if (ticketStatus != 3) {
      let duration = await getTimeDuration(data);
      let tkDuration = await getTkStartEndTime(data);
      if (duration || tkDuration) {
        data.duration_time = duration;
        data.tk_start_end_duration = tkDuration;
      }
      setModalShow(true);
      getTicketAudit(data);
      setTicketPop(data);
    }
  }

  const handleClick = async (event, data) => {
    const selectedIndex = selected.findIndex((x) => x.tk_no == data.tk_no);
    let newSelected = [];

    if (selectedIndex === -1) {
      let duration = await getTimeDuration(data);
      let tkDuration = await getTkStartEndTime(data);
      if (duration || tkDuration) {
        data.duration_time = duration;
        data.tk_start_end_duration = tkDuration;
      }
      newSelected = newSelected.concat(selected, data);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    ////console.log('newSelected', newSelected);
    setSelected(newSelected);
  };

  const isSelectedElement = (ticket_id) => {
    //selected?.findIndex((x) => x.ticket_id == ticket_id) !== -1;
    ////console.log("selected: ",selected?.findIndex((x) => x.ticket_id == ticket_id))
    if (selected?.findIndex((x) => x.ticket_id == ticket_id) !== -1) {
      return true;
    } else {
      return false;
    }
  };

  const handleClose = () => {
    setModalShow(false);
    setOpen(false);
    setSendEmails(false);
  };

  const handleClickOpen = (n) => {
    setOpen(true);
    setDelete(n.tk_id);
    setTicketType(n.ticket_owner_type);
  };

  const handleChangeStart = (position, starttime) => {
    let tk_start = getValues('tk_start');
    for (let i = 0; i < tk_start.length; i++) {
      if (position == i) {
        tk_start[i] = starttime;
      }
    }
    setTkStart(tk_start);
  };

  const handleChangeEnd = (position, endtime) => {
    let tk_end = getValues('tk_end');
    for (let i = 0; i < tk_end.length; i++) {
      if (position == i) {
        tk_end[i] = endtime;
      }
    }
    setTkEnd(tk_end);
  };

  const fillWaitPreview = (starts, ends, rate, fillEmptyRate = false) => {
    const typed = Number(String(rate ?? '').replace(/[$,]/g, ''));
    const billRate = typed > 0 ? typed : fillEmptyRate && companyWaitRate > 0 ? companyWaitRate : typed;
    if (fillEmptyRate && !(typed > 0) && billRate > 0) {
      setValue('tk_wait_rate', billRate);
    }
    const cost = previewWaitCost(starts, ends, Number.isFinite(billRate) ? billRate : 0);
    if (cost != null) setValue('wait_cr', formatter.format(cost));
  };

  const handleChangeWaitStart = (position, waitstarttime) => {
    const current = getValues('tk_wait_start')?.length
      ? [...getValues('tk_wait_start')]
      : [...(tkwaitstart || [])];
    current[position] = waitstarttime;
    setTkwaitstart(current);
    setValue('tk_wait_start', current);
    fillWaitPreview(current, getValues('tk_wait_end'), getValues('tk_wait_rate'), true);
  };

  const handleChangeWaitEnd = (position, waitendtime) => {
    const current = getValues('tk_wait_end')?.length
      ? [...getValues('tk_wait_end')]
      : [...(tkwaitend || [])];
    current[position] = waitendtime;
    setTkwaitend(current);
    setValue('tk_wait_end', current);
    fillWaitPreview(getValues('tk_wait_start'), current, getValues('tk_wait_rate'), true);
  };
  const [editTkScaleImage, setEditTkScaleImage] = useState([]);
  const [openScaleImageUploader, setOpenScaleImageUploader] = useState(false);
  const [editingTicket, setEditingTicket] = useState(null);
  const [deleteWaitTime, setDeleteWaitTime] = useState([]);
  // Dropdown selection for job billing history changes (job_<entry_id>), blank means "nothing selected yet"
  const [recalcWith, setRecalcWith] = useState('');
  const [recalcLoading, setRecalcLoading] = useState(false);
  const [jobBillingHistory, setJobBillingHistory] = useState([]);
  const [jobBillingHistoryLoading, setJobBillingHistoryLoading] = useState(false);
  const [lastEditPreviewOpen, setLastEditPreviewOpen] = useState(false);
  const [lastEditPreview, setLastEditPreview] = useState(null);
  const [lastEditPreviewLoading, setLastEditPreviewLoading] = useState(false);
  const [lastEditBannerVisible, setLastEditBannerVisible] = useState(false);
  const [lastEditRevertSnapshot, setLastEditRevertSnapshot] = useState(null);

  const handleClickEdit = (n) => {
    console.log('N: ', n);
    notifyPastDue();
    setEditingTicket(n);
    setOpenEdit(true);
    setLastEditPreview(null);
    setLastEditBannerVisible(false);
    setLastEditRevertSnapshot(null);
    setRecalcWith(
      n?.recalc_with_job_entry_id != null && n?.recalc_with_job_entry_id !== ''
        ? `job_${n.recalc_with_job_entry_id}`
        : ''
    );
    setTkwaitstart([]);
    setTkwaitend([]);
    setJobBillingHistory([]);
    const job_id = n.tk_job_id ?? n.job_id;
    setJobBillingHistoryLoading(true);
    client
      .post('/ticket/job-billing-history', job_id ? { job_id } : { tk_id: n.tk_id })
      .then((res) => {
        const list = Array.isArray(res?.data) ? res.data : [];
        setJobBillingHistory(list);
        // Do not auto-select or auto-recalculate; user must pick an option
      })
      .catch(() => setJobBillingHistory([]))
      .finally(() => setJobBillingHistoryLoading(false));

    //Note: this logic to support old login of scale image array
    let _scaleImage =
      n?.scale_image_timestamp && n?.scale_image_timestamp?.length
        ? n?.scale_image_timestamp
        : n?.scale_ticket_image && n?.scale_ticket_image.length
        ? Array.isArray(n?.scale_ticket_image)
          ? map(n?.scale_ticket_image, (i) => ({ key: i }))
          : [{ key: n?.scale_ticket_image }]
        : [];

    if (_scaleImage) {
      if (typeof _scaleImage === 'string') {
        //console.log('is string', _scaleImage)
        while (typeof _scaleImage === 'string') {
          _scaleImage = JSON.parse(_scaleImage);
        }
        setEditTkScaleImage(_scaleImage);
      } else if (typeof _scaleImage === 'object') {
        //console.log('is object', _scaleImage)
        setEditTkScaleImage(_scaleImage);
      }
    }

    setTicketType(n.ticket_owner_type);
    setDelete(n.tk_id);
    settkNo(n.tk_no);
    setValue('tk_qty', n.tk_qty);
    const ticket_rate = Number(n.ticket_cr.replace(/[$,]/g, '')) / Number(n.tk_qty);
    const ticket_rate_rounded = Math.round(ticket_rate * 100) / 100;
    setValue(
      'tk_rate',
      isNaN(ticket_rate_rounded) || !isFinite(ticket_rate_rounded)
        ? 0.0
        : parseFloat(ticket_rate_rounded).toFixed(2)
    );
    const subconTicketCost =
      Math.round((Number(n?.subcon_ticket_cost?.replace(/[$,]/g, '')) / Number(n?.tk_qty)) * 100) /
      100;
    setValue(
      'tk_cost',
      n?.ticket_owner_type == 'EMP'
        ? isNaN(n?.calced_cpu)
          ? 0
          : n?.calced_cpu
        : n?.ticket_owner_type == 'OP'
        ? isNaN(subconTicketCost)
          ? 0
          : subconTicketCost
        : isNaN(subconTicketCost)
        ? 0
        : subconTicketCost
    );
    const tkMatRate =
      Math.round((Number(n?.material_cr.replace(/[$,]/g, '')) / Number(n?.tk_qty)) * 100) / 100;
    const tkMatCost =
      Math.round((Number(n?.material_dr?.replace(/[$,]/g, '')) / Number(n?.tk_qty)) * 100) / 100;
    setValue('tk_mat_rate', isNaN(tkMatRate) ? 0 : tkMatRate);
    setValue('tk_mat_cost', isNaN(tkMatCost) ? 0 : tkMatCost);
    setValue('tk_wait_rate', formatWaitRateForInput(n?.tk_wait_rate));
    setValue('tk_pay', n?.tk_pay);
    setValue('tk_scale_no', n.tk_scale_no);
    setValue('tk_datecreated', n.date_created);
    setValue('truck_id', n.truck_id);
    setValue('tk_status', n.tk_status);
    setValue('tk_job_no', n.tk_job_no);
    setValue('driver_id', n.driver_id);
    setValue('ticket_cr', n.ticket_cr);
    setValue(
      'hauling_cost',
      n?.ticket_owner_type == 'EMP'
        ? formatter.format(n?.calced_cpu * Number(n?.tk_qty))
        : n?.ticket_owner_type == 'OP'
        ? n?.subcon_ticket_cost
        : n?.subcon_ticket_cost
    ); //hauling cost
    setValue('material_cr', n?.material_cr); //material credit
    setValue('material_dr', n?.material_dr); //material cost
    setValue('wait_cr', n?.wait_cr); //wait cost
    setValue('employee_ticket_cost', n?.employee_ticket_cost); //employee cost

    //console.log('tk:: start', n.tk_start);
    if (n.tk_start) {
      for (let i = 0; i < n.tk_start.length; i++) {
        const format_start =
          moment.tz(n.tk_start[i], moment.tz.guess(true)).format('HH:mm:ss') == 'Invalid date'
            ? moment
                .tz(`${moment().format('YYYY-MM-DD')} ` + n.tk_start[i], moment.tz.guess(true))
                .format()
            : moment.tz(n.tk_start[i], moment.tz.guess(true)).format();
        //console.log('format_start', format_start);
        n.tk_start[i] = format_start;
      }
      setTkStart(n.tk_start);
      setValue('tk_start', n.tk_start);
    }

    if (n.tk_end) {
      for (let i = 0; i < n.tk_end.length; i++) {
        const format_end =
          moment.tz(n.tk_end[i], moment.tz.guess(true)).format('HH:mm:ss') == 'Invalid date'
            ? moment
                .tz(`${moment().format('YYYY-MM-DD')} ` + n.tk_end[i], moment.tz.guess(true))
                .format()
            : moment.tz(n.tk_end[i], moment.tz.guess(true)).format();
        //console.log('format_end', format_end);
        n.tk_end[i] = format_end;
      }
      setTkEnd(n.tk_end);
      setValue('tk_end', n.tk_end);
    }

    if (!n.tk_wait_start) {
      setValue('tk_wait_start', null);
      setValue('tk_wait_end', null);
    }
    if (n.tk_wait_start) {
      for (let i = 0; i < n.tk_wait_start.length; i++) {
        const format_start =
          moment.tz(n.tk_wait_start[i], moment.tz.guess(true)).format('HH:mm:ss') == 'Invalid date'
            ? moment
                .tz(`${moment().format('YYYY-MM-DD')} ` + n.tk_wait_start[i], moment.tz.guess(true))
                .format()
            : moment.tz(n.tk_wait_start[i], moment.tz.guess(true)).format();
        n.tk_wait_start[i] = format_start;
      }
      setTkwaitstart(n.tk_wait_start);
      setValue('tk_wait_start', n.tk_wait_start);
    }

    if (n.tk_wait_end) {
      for (let i = 0; i < n.tk_wait_end.length; i++) {
        const format_end =
          moment.tz(n.tk_wait_end[i], moment.tz.guess(true)).format('HH:mm:ss') == 'Invalid date'
            ? moment
                .tz(`${moment().format('YYYY-MM-DD')} ` + n.tk_wait_end[i], moment.tz.guess(true))
                .format()
            : moment.tz(n.tk_wait_end[i], moment.tz.guess(true)).format();
        n.tk_wait_end[i] = format_end;
      }
      setTkwaitend(n.tk_wait_end);
      setValue('tk_wait_end', n.tk_wait_end);
    }

    // Re-apply job billing history rates even when the same option is already selected (no onChange).
    // Runs after row data fills the form so recalc overwrites stale tk_rate / tk_cost / etc.
    // Then auto-apply last manual edit correction so Cost Rate etc. match the last edit.
    const runLastEditAutoApply = () => {
      if (n?.tk_id) {
        fetchLastEditCorrection(n.tk_id, { openDialog: false, autoApply: true });
      }
    };
    if (n?.recalc_with_job_entry_id != null && n?.recalc_with_job_entry_id !== '') {
      const jobKey = `job_${n.recalc_with_job_entry_id}`;
      queueMicrotask(() => {
        Promise.resolve(handleRecalcValues(jobKey, { tk_id: n.tk_id })).finally(runLastEditAutoApply);
      });
    } else {
      runLastEditAutoApply();
    }
  };

  const handleDeleteEditScaleImage = (index) => {
    let newImages = editTkScaleImage;
    newImages.splice(index, 1);
    setEditTkScaleImage([...newImages]);
  };

  const handleAddEditScaleImage = (file) => {
    setEditTkScaleImage((prev) => [...prev, { file }]);
  };

  const handleCloseEdit = () => {
    setModalShow(false);
    setOpenEdit(false);
    setSendEmails(false);
    setEditTkScaleImage([]);
    setEditingTicket(null);
    setDeleteWaitTime([]);
    setLastEditPreview(null);
    setLastEditPreviewOpen(false);
    setLastEditBannerVisible(false);
    setLastEditRevertSnapshot(null);
    setInvoiceEditConfirm({ open: false, invoice_no: null });
  };

  const JobTransfer = async (confirmZeroInvoice = false, existingPayload = null) => {
    //console.log('Job Transfer', selected);
    if (!confirmZeroInvoice) {
      if (newticketjob == null || newticketjob == undefined) {
        return _showMessage(t('PLEASE_SELECT_A_VALID_JOB'), 'error');
      }
      if (insertInvoice == true && selectedInvoice == null) {
        return _showMessage(t('PLEASE_SELECT_A_VALID_INCOICE'), 'error');
      }
      if (newticketjob.job_id == id) {
        return _showMessage(t('CANNOT_TRANSFER_TICKETS_TO_THE_SAME_JOB'), 'error');
      }
      setJobTransfer(false);
    }
    setLoadingBar(true);

    let payload = existingPayload;
    if (!payload) {
      const button_log_tickets = selected.map((e) => {
        return {
          tk_id: e.tk_id,
          tk_no: e.tk_no,
          is_op: e.ticket_owner_type == 'OP' ? true : false,
          ticket_owner_type: e.ticket_owner_type,
        };
      });

      ButtonLog({
        type: 'ticket',
        button_name: 'ticket_job_transfer',
        info: `ticket job transfer w/${
          leaveTkAlone
            ? ' not invoice ticket'
            : singleInvoice
            ? ' invoice alone'
            : insertInvoice
            ? ` insert into invoice: ${selectedInvoice.value}`
            : ' not invoice ticket'
        } --- transferring these tickets: ${JSON.stringify(button_log_tickets)} from job id ${
          id ? id : job_id
        } to job no. ${newticketjob.value} `,
      });

      const subRequestTickets = [];
      for (const e of selected) {
        if (e.ticket_owner_type == 'SUB') {
          subRequestTickets.push(e);
          await client.post(`/requests/`, {
            id: prop_data
              ? prop_data.id
              : user?.company?.staff_id == '0'
              ? user?.user_id
              : user?.company?.staff_id,
            compacctnum: comp_acct,
            request_info: e.tk_id,
            type: 'clone ticket transfer',
            date: moment().format('YYYY-MM-DD'),
            time: moment().format('HH:mm'),
            reason: 'transferring ticket',
            job_id: newticketjob.job_id,
          });
        }
      }

      const tickets = selected
        .filter((e) => e.ticket_owner_type != 'SUB')
        .map((e) => ({
          tk_id: e.tk_id,
          tk_no: e.tk_no,
          is_op: e.ticket_owner_type == 'OP' ? true : false,
          ticket_owner_type: e.ticket_owner_type,
        }));

      if (tickets.length === 0) {
        if (subRequestTickets.length > 0) {
          _showMessage(
            'Transfer request created. The job owner must approve it before the ticket is moved.',
            'success'
          );
          setSendEmails(false);
          setSelected([]);
          setInsertInvoice(false);
          setLoadingBar(false);
          setNewTicketJob();
          setTransferSearch('');
          setLeaveTkAlone(true);
          setSingleInvoice(false);
          setSelectedInvoice(null);
          setJobInvoices({ job_id: null, invoices: [] });
        }
        return;
      }

      payload = {
        tickets,
        job_no: newticketjob.value,
        comp_acct: prop_data ? prop_data.compacctnum : user?.company?.compacctnum,
        send_emails: sendEmails,
        invoice_id: selectedInvoice ? selectedInvoice.value : null,
        inv_option: leaveTkAlone ? 0 : singleInvoice ? 1 : insertInvoice ? 2 : 0,
        user_id: user?.staff ? user?.staff?.staff_u_id : user?.user_id,
        confirm_zero_invoice: false,
      };
    } else {
      payload = { ...existingPayload, confirm_zero_invoice: true };
    }

    await transferJobTickets(
      payload,
      async (result) => {
        if (result?.data?.code === 'ZERO_INVOICE_TRANSFER_CONFIRMATION_REQUIRED') {
          setZeroInvoiceConfirm({
            open: true,
            invoice_no: result.data.invoice_no,
            message: result.data.err_message,
            payload,
          });
          setLoadingBar(false);
          return;
        }
        if (result?.data?.err_message) {
          _showMessage(result.data.err_message, 'error');
          setSendEmails(false);
        } else if (result?.data?.complete) {
          _showMessage(result.data.message || t('JOB_TRNSFER_COMPLETED'), 'success');
          setSendEmails(false);
        } else if (result?.data?.message) {
          _showMessage(result.data.message, 'error');
          setSendEmails(false);
        }

        setSelected([]);
        await getAllTicketJobs(
          {
            page: 1,
            data: {
              id: job_id ? job_id : id,
              estatus: ticketStatus,
              compacctnum: prop_data ? prop_data?.compacctnum : user.company.compacctnum,
            },
          },
          (e) => {
            //console.log(e);
          }
        );
        setInsertInvoice(false);
        setLoadingBar(false);
        setNewTicketJob();
        setTransferSearch('');
        setLeaveTkAlone(true);
        setSingleInvoice(false);
        setSelectedInvoice(null);
        setJobInvoices({ job_id: null, invoices: [] });
      },
      (error) => {
        if (error) {
          //console.log(error);
          // return _showMessage(error,'error')
          setLoadingBar(false);
          setInsertInvoice(false);
          setNewTicketJob();
          setTransferSearch('');
          setLeaveTkAlone(true);
          setSingleInvoice(false);
          setSelectedInvoice(null);
          setJobInvoices({ job_id: null, invoices: [] });
        }
      }
    );
    //must deselect selected and then call tickets to load again
  };

  useEffect(async () => {
    let key = prop_data ? prop_data?.logo : user.company?.logo;
    let logoRes = await getS3Location(key);
    if (logoRes && logoRes.data && logoRes.data.data) {
      logoRes.data.data.logoKey = key;
      setCompLogo(logoRes.data.data);
    }
  }, [prop_data?.logo, user.company?.logo]);

  const onScroll = async (event) => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight, scrollLeft, offsetHeight } =
        listInnerRef.current;
      const allow = scrollLeft > scrollX || scrollLeft < scrollX ? false : true;
      setScrollX(scrollLeft);
      if (offsetHeight + scrollTop >= scrollHeight && allow) {
        if (hasNextPage && !search && !date1 && !date2) {
          /* This will be triggered after hitting the last element. API call should be made he-re while implementing pagination. */
          await getAllTicketJobs(
            {
              page: page + 1,
              data: {
                id: job_id ? job_id : id,
                estatus: ticketStatus,
                compacctnum: prop_data ? prop_data?.compacctnum : user.company.compacctnum,
              },
            },
            (err) => {
              //console.log(err);
            }
          );
        }
      }
    }
  };

  // Consolidated useEffect to prevent multiple API calls
  useEffect(async () => {
    setSelected([]);
    
    // Handle search functionality
    if (search && search.length > 2) {
      await searchJobTickets(
        {
          id: job_id ? job_id : id,
          searchText: search,
          accountNumber: compacctnum,
          selectedTab: ticketStatus,
        },
        (error) => {
          //console.log(error);
        }
      );
      return; // Exit early to avoid duplicate calls
    }

    // Handle date range search
    if (date1 && date2) {
      onSearchDate();
      return; // Exit early to avoid duplicate calls
    }

    // Default: fetch all ticket jobs (only if no search or date filters)
    if (!search && !date1 && !date2) {
      await getAllTicketJobs(
        {
          page: 1,
          data: {
            id: job_id ? job_id : id,
            estatus: ticketStatus,
            compacctnum: prop_data ? prop_data?.compacctnum : user.company.compacctnum,
          },
        },
        (err) => {
          //console.log(err);
        }
      );
    }
  }, [search, date1, date2, ticketSearch, ticketStatus]);

  useEffect(async () => {
    if (jobTransfer) {
      await getAllJobs({ page: 1, filter: null, compacctnum }, (error) => {
        //console.log(error);
      });
    }
  }, [jobTransfer]);

  useEffect(async () => {
    const small_comp_id = prop_data ? prop_data.company_id : user?.company?.company_id;
    const result = jobs.map((e) => {
      return { value: e.job_no, label: small_comp_id + '-' + e.job_no, job_id: e.job_info_id };
    });
    setAllJobs(result);
  }, [jobs]);

  useEffect(async () => {
    //console.log('get drivers and trucks');
    setTruckDriverLoading(true);
    getDrivers({ compacctnum }, (error) => {
      //console.log(error);
    });

    getTrucks({ comp_acct: prop_data ? prop_data.id : user?.user_id, web: 1 }, (error) => {
      //console.log(error);
    });
    setTruckDriverLoading(false);
  }, []);

  const renderEditButton = (n) => {
    if (hasPermission('ticket.update') || prop_data) {
      return (
        <IconButton
          onClick={(event) =>
            n.ticket_owner_type == 'SUB'
              ? open_reqedit(n)
              : n.ticket_owner_type == 'OP'
              ? handleClickEdit(n)
              : handleClickEdit(n)
          }
        >
          <Icon style={{ color: '#edca33' }}>edit</Icon>
        </IconButton>
      );
    }
  };

  const renderDeleteButton = (n) => {
    if (hasPermission('ticket.delete') || prop_data) {
      return (
        <IconButton
          onClick={(event) =>
            n.ticket_owner_type == 'SUB'
              ? open_reqdelete(n)
              : n.ticket_owner_type == 'OP'
              ? handleClickOpen(n)
              : handleClickOpen(n)
          }
        >
          <Icon style={{ color: '#edca33' }}>delete</Icon>
        </IconButton>
      );
    }
  };

  const renderTicketAudit = (n) => {
    if (hasPermission('ticket.browse') || prop_data) {
      return (
        <IconButton onClick={() => getTicketAudit(n)}>
          <Icon style={{ color: '#edca33' }}>info</Icon>
        </IconButton>
      );
    }
  };
  const handleSearch = async (e) => {
    //console.log(e.target.value);
    setTransferSearch(e.target.value);
    if (e.target.value.length > 0) {
      if (e.target.value.replace(/\s/g, '').length > 0) {
        await searchJobs(
          { page: 1, text: e.target.value, search: 'archive', compacctnum },
          (error) => {
            //console.log(error);
          }
        );
      }
    } else {
      getAllJobs({ page: 1, filter: null, compacctnum });
    }
  };

  const getFormatedTime = (tk_time) => {
    const newtk = [];
    if (tk_time) {
      tk_time.forEach(function (element, indice) {
        if (newtk.length > 0) {
          newtk.push(' - ');
        }
        if (element.length > 10) {
          newtk.push(moment(element).format('hh:mm:ss A'));
        } else {
          newtk.push(moment(element, 'HH:mm:ss').format('hh:mm:ss A'));
        }
      });
    }

    return newtk;
  };

  const [jobInvoices, setJobInvoices] = useState({ job_id: null, invoices: [] });

  useEffect(async () => {
    if (newticketjob?.job_id && insertInvoice && jobTransfer == true) {
      if (jobInvoices?.job_id != newticketjob?.job_id) {
        const result = await client.post('invoices/job-invoices', {
          job_id: newticketjob?.job_id,
          compacctnum: comp_acct,
        });
        //console.log('result >> ', result.data);
        if (result.data.length == 0) {
          setJobInvoices({ job_id: newticketjob?.job_id, invoices: null });

          return _showMessage(t('NO_INVOICES_FOUND'), 'warning');
        } else {
          const fixed_invoices = result.data.map((e) => {
            return {
              value: e.id,
              label: `Invoice No: ${e.invoice_no} Balance: ${e.invoice_balance}`,
            };
          });

          setJobInvoices({ job_id: newticketjob?.job_id, invoices: fixed_invoices });
        }
      }
    }

    if (!newticketjob?.job_id && insertInvoice && jobTransfer == true) {
      _showMessage(t('SELECT_A_JOB'), 'warning');
    }
  }, [insertInvoice, newticketjob]);

  const [invoicesLoading, setInvoicesLoading] = useState(false);
  const [invoiceTransfer, setInvoiceTransfer] = useState(false);

  const InvoiceTransfer = async () => {
    if (selectedInvoice == null) {
      return _showMessage(t('PLEASE_SELECT_AN_INVOICE'), 'error');
    }
    //console.log('Current Job Id >> ', id);
    //console.log('Selected Tickets >> ', selected);
    let tickets = selected.map((e) => {
      if (Number(e.invoice_id) != selectedInvoice.value) {
        return e.tk_id;
      }
    });
    tickets = tickets.filter((e) => e != null);
    //console.log('Selected Invoice >> ', selectedInvoice);
    const invoice_id = selectedInvoice.value;
    //console.log('Send emails >> ', sendEmails);
    const sendEmail = sendEmails;
    ButtonLog({
      type: 'ticket',
      button_name: 'ticket_invoice_transfer',
      info: `ticket invoice transfer --- transferring these tickets: ${JSON.stringify(
        tickets
      )} in job id ${id ? id : job_id} to invoice id ${invoice_id}`,
    });
    const result = await client.post('invoices/move-tk-invoice', {
      tickets,
      invoice_id,
      sendEmail,
      user_id: user?.staff ? user?.staff?.staff_u_id : user?.user_id,
    });

    //console.log('result >> ', result.data);
    if (result.data.message == 'success') {
      _showMessage(t('SUCCESS'), 'success');
      setSendEmails(false);
      setInvoiceTransfer(false);
      setSelectedInvoice(null);
      setJobInvoices({ job_id: null, invoices: [] });
      setSelected([]);
    } else {
      _showMessage(t('ERROR'), 'error');
      setSendEmails(false);
      setInvoiceTransfer(false);
      setSelectedInvoice(null);
      setJobInvoices({ job_id: null, invoices: [] });
      setSelected([]);
    }
  };

  useEffect(async () => {
    if (invoiceTransfer == true) {
      if (jobInvoices?.job_id != id) {
        setInvoicesLoading(true);
        const result = await client.post('invoices/job-invoices', {
          job_id: id,
          compacctnum: comp_acct,
        });
        //console.log('result >> ', result.data);
        setInvoicesLoading(false);
        if (result.data.length == 0) {
          setJobInvoices({ job_id: id, invoices: null });

          return _showMessage(t('NO_INVOICES_FOUND'), 'warning');
        } else {
          const fixed_invoices = result.data.map((e) => {
            return {
              value: e.id,
              label: `${t('INVOICE_NO_COLON')} ${e.invoice_no} ${t('BALANCE_COLON')} ${
                e.invoice_balance
              }`,
            };
          });

          setJobInvoices({ job_id: id, invoices: fixed_invoices });
        }
      }
    }
  }, [invoiceTransfer]);

  const checkJobTransfer = async () => {
    // used to prevent multi transfers for tickets taht belong to another company
    /*  let not_open = false;

    await Promise.all(
      selected.map((e) => {
        if (e.ticket_owner_type == 'SUB') {
          not_open = true;
        }
      })
    );

    if (not_open == true) {
      return _showMessage(
        'One or more of the tickets that you have selected belongs to a Subcontractor. If you want to transfer these tickets create a request.',
        'warning'
      );
    } else {
      setJobTransfer(true);
    } */

    setJobTransfer(true);
  };

  const [driverOptions, setDriverOptions] = useState([]);

  useEffect(() => {
    if (drivers && drivers.length > 0) {
      drivers.sort((a, b) => {
        const nameA = a.user_fname.toUpperCase() + a.user_lname.toUpperCase(); // Ignore case
        const nameB = b.user_fname.toUpperCase() + b.user_lname.toUpperCase(); // Ignore case
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0; // names must be equal
      });

      const driverOptions = drivers.map((driver) => {
        return {
          value: driver.dr_user_id,
          label: driver.user_fname + ' ' + driver.user_lname,
        };
      });

      //make sure there are no duplicates in driverOptions array
      const uniqueDriverOptions = driverOptions.filter(
        (driver, index, self) => index === self.findIndex((t) => t.value === driver.value)
      );

      setDriverOptions(uniqueDriverOptions);
    }
  }, [drivers]);

  const [ticketAudit, setTicketAudit] = useState(false);
  const [ticketAuditData, setTicketAuditData] = useState([]);
  const [auditLoading, setAuditLoading] = useState(false);
  const getTicketAudit = async (ticket) => {
    try {
      ////console.log('Ticket info: ',ticket)
      //setTicketAudit(true)
      setAuditLoading(true);

      const result = await client.post(`ticket/audit`, {
        tk_id: ticket.tk_id,
        compacctnum: ticket.c_id,
      });
      ////console.log('data: ',result)

      if (result.data.length) {
        setTicketAuditData(result.data);
      } else {
        setTicketAuditData([]);
      }
      setAuditLoading(false);
    } catch (error) {
      setAuditLoading(false);
      //console.log(error)
      setTicketAuditData([]);
      _showMessage(t('ERROR'), 'error');
    }
  };

  const [openScaleImageDialog, setOpenScaleImageDialog] = useState(false);
  const [scaleImages, setScaleImages] = useState(null);
  const [scaleTicketImageUploadLimit, setScaleTicketImageUploadLimit] = useState(null);
  const DEFAULT_SCALE_IMAGE_UPLOAD_LIMIT = 10;

  const getCompanyDetail = async () => {
    try {
      const result = await client.post('/company/compacct', { id: user?.company?.compacctnum });
      if (result?.data?.scale_ticket_image_length) {
        setScaleTicketImageUploadLimit(result?.data?.scale_ticket_image_length);
      }
      const parsedWait = Number(String(result?.data?.wait_rate ?? '').replace(/[$,]/g, ''));
      if (Number.isFinite(parsedWait) && parsedWait > 0) {
        setCompanyWaitRate(parsedWait);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (user?.company?.compacctnum) {
      getCompanyDetail();
    }
  }, [user?.company]);

  useEffect(() => {
    if (!openedit || !(companyWaitRate > 0)) return;
    const starts = getValues('tk_wait_start');
    const showingWait =
      editingTicket?.tk_type == 1 ||
      editingTicket?.tk_type == 2 ||
      (Array.isArray(starts) && starts.length > 0);
    if (!showingWait) return;
    // An edit already saved wait rate 0 (no wait charge); do not swap in the company rate.
    if (editingTicket?.wait_rate_zero_saved) return;
    const current = Number(String(getValues('tk_wait_rate') ?? '').replace(/[$,]/g, ''));
    const cost = Number(String(getValues('wait_cr') ?? '').replace(/[$,]/g, ''));
    if (current > 0 || cost > 0) return;
    setValue('tk_wait_rate', companyWaitRate);
    const preview = previewWaitCost(starts, getValues('tk_wait_end'), companyWaitRate);
    setValue('wait_cr', formatter.format(preview || 0));
  }, [openedit, companyWaitRate, editingTicket]);

  const allowToUploadScaleTicketImage = useMemo(() => {
    const limit = scaleTicketImageUploadLimit ?? DEFAULT_SCALE_IMAGE_UPLOAD_LIMIT;
    return editTkScaleImage?.length < limit;
  }, [scaleTicketImageUploadLimit, DEFAULT_SCALE_IMAGE_UPLOAD_LIMIT, editTkScaleImage]);

  return (
    <div style={{ marginBottom: '5rem' }}>
      <ScaleImageDialog
        openScaleImageDialog={openScaleImageDialog}
        setOpenScaleImageDialog={setOpenScaleImageDialog}
        scaleImages={scaleImages}
        setScaleImages={setScaleImages}
      />

      <Dialog
        open={deleteTicketLoading || updateTicketLoading}
        fullScreen
        disableEscapeKeyDown
        sx={{ zIndex: (theme) => theme.zIndex.modal + 2 }}
        PaperProps={{
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        }}
      >
        <div className='flex flex-row items-center align-center justify-center w-full h-full'>
          <CircularLoader color={updateTicketLoading ? '#edca33' : '#000000'} />
        </div>
      </Dialog>

      {/**Ticket Audit Data  */}
      <Dialog open={ticketAudit} maxWidth={'md'}>
        <DialogTitle sx={{ boxShadow: '3' }}>
          <Typography variant='h4'>{t('TICKET_AUDIT')}</Typography>
        </DialogTitle>
        <DialogContent
          className='flex flex-col items-center text-center align-center justify-center overflow-y-auto'
          sx={{ maxHeight: '500px' }}
        >
          {auditLoading ? (
            <div className='pt-12'>
              <CircularLoader />
            </div>
          ) : ticketAuditData.length == 0 ? (
            <div className='pt-12'>
              <Typography variant='h6'>{t('NO_AUNDIT_DATA_FOUND')}</Typography>
            </div>
          ) : (
            <Timeline sx={{ height: '40vh' }}>
              {ticketAuditData.map((audit) => {
                return (
                  <TimelineItem>
                    <TimelineOppositeContent display={'none'} />
                    <TimelineSeparator>
                      <TimelineDot />
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                      <span>{audit.name + ' made a change to the ticket:'}</span>
                      <br />
                      <span>{audit.description} </span>on{' '}
                      {moment(audit.date).format('MMMM Do YYYY, h:mm:ss a')}
                    </TimelineContent>
                  </TimelineItem>
                );
              })}
            </Timeline>
          )}
        </DialogContent>
        <DialogActions sx={{ boxShadow: '5' }}>
          <Button onClick={() => setTicketAudit(false)}>{t('CLOSE')}</Button>
        </DialogActions>
      </Dialog>

      <ModalViewScale
        scaleImage={scaleImage}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      ></ModalViewScale>

      <Dialog
        fullWidth={false}
        maxWidth={'sm'}
        open={jobTransfer}
        onClose={() => {
          setJobTransfer(false);
          setNewTicketJob();
          setTransferSearch('');
          setLeaveTkAlone(true);
          setSingleInvoice(false);
          setInsertInvoice(false);
          setSelectedInvoice(null);
          setJobInvoices({ job_id: null, invoices: [] });
        }}
      >
        <DialogTitle>{t('TICKET_JOB_TRANSFER')}</DialogTitle>
        <DialogContent className='flex flex-row' sx={{ width: 450 }}>
          <Autocomplete
            disableListWrap
            clearOnBlur={false}
            freeSolo={true}
            id='job-transfer-box'
            value={newticketjob}
            onChange={(e, newValue) => {
              //console.log(newValue);
              setNewTicketJob(newValue);
            }}
            options={allJobs}
            loading={true}
            sx={{ width: 300, padding: 0 }}
            ListboxProps={{
              onScroll: async (event) => {
                const listboxNode = event.currentTarget;
                if (listboxNode.scrollTop + listboxNode.clientHeight === listboxNode.scrollHeight) {
                  if (jobTransfer && hasNextJob) {
                    //if search then scroll on search
                    if (transfersearch.length > 0) {
                      if (transfersearch.replace(/\s/g, '').length > 0) {
                        await searchJobs(
                          {
                            page: jobPage + 1,
                            text: event.target.value,
                            search: 'archive',
                            compacctnum,
                          },
                          (error) => {
                            //console.log(error);
                          }
                        );
                      }
                    } else {
                      getAllJobs({ page: jobPage + 1, filter: null, compacctnum });
                    }
                  }
                }
              },
              style: { maxHeight: '15rem' },
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={t('JOB')}
                sx={{ padding: 0 }}
                onChange={(e) => handleSearch(e)}
              />
            )}
            renderOption={(props, option) => <li {...props}>{option.label}</li>}
          />

          <div className=' flex flex-row pl-16 items-center'>
            <Tooltip
              title={t('INVOICING_OPTIONS_ONLY_AFFECT_OWENER_OPERATOR_AND_EMPLOYEE_MESSAGE')}
              placement='right-start'
            >
              <Button variant='contained' sx={{ height: '45px' }} onClick={() => JobTransfer()}>
                <Typography fontWeight={'bold'}>{t('TRANSFER')}</Typography>
              </Button>
            </Tooltip>
          </div>
        </DialogContent>
        <div className='flex flex-row w-full pl-24 pb-8'>
          {insertInvoice && jobInvoices?.invoices && jobInvoices?.invoices.length > 0 ? (
            <Autocomplete
              disableListWrap
              clearOnBlur={false}
              freeSolo={false}
              id='invoice-transfer-box'
              value={selectedInvoice}
              onChange={(e, newValue) => {
                //console.log(newValue);
                setSelectedInvoice(newValue);
              }}
              options={jobInvoices?.invoices}
              loading={true}
              sx={{ width: 300, padding: 0 }}
              renderInput={(params) => (
                <TextField {...params} placeholder={t('INVOICE')} sx={{ padding: 0 }} />
              )}
              renderOption={(props, option) => <li {...props}>{option.label}</li>}
            />
          ) : null}
        </div>

        <div className='flex flex-col items-start pl-24 pb-8 text-black'>
          <div className='flex flex-row items-center pb-8'>
            <Checkbox
              className='p-0'
              checked={sendEmails}
              onChange={(e) => {
                setSendEmails(e.target.checked);
              }}
            />
            <span className='pl-8'>{t('SEND_UPDATED_INVOICE_TO_CUSTOMER')}</span>
          </div>

          <div className='flex flex-row items-center pb-8'>
            <Checkbox
              className='p-0'
              checked={leaveTkAlone}
              onChange={(e) => {
                setLeaveTkAlone(true);
                setInsertInvoice(false);
                setSingleInvoice(false);
                setSelectedInvoice(null);
              }}
            />
            <span className='pl-8'>{t('DO_NOT_INVOICE_TICKETS')}</span>
          </div>

          <div className='flex flex-row items-center pb-8'>
            <Checkbox
              className='p-0'
              checked={insertInvoice}
              onChange={(e) => {
                setInsertInvoice(true);
                setLeaveTkAlone(false);
                setSingleInvoice(false);
                setSelectedInvoice(null);
              }}
            />
            <span className='pl-8'>{t('ADD_TO_EXISTING_INVOICE')}</span>
          </div>

          <div className='flex flex-row items-center pb-8'>
            <Checkbox
              className='p-0'
              checked={singleInvoice}
              onChange={(e) => {
                setSingleInvoice(true);
                setLeaveTkAlone(false);
                setInsertInvoice(false);
                setSelectedInvoice(null);
              }}
            />
            <span className='pl-8'>{t('CREATE_NEW_INVOICE')}</span>
          </div>
        </div>

        <DialogActions>
          <Button
            onClick={() => {
              setSendEmails(false);
              setJobTransfer(false);
              setNewTicketJob();
              setSingleInvoice(false);
              setLeaveTkAlone(false);
              setInsertInvoice(false);
              setSelectedInvoice(null);
            }}
          >
            {t('CLOSE')}
          </Button>
        </DialogActions>
      </Dialog>

      {/**Invoice Transfer */}
      <Dialog
        fullWidth={false}
        maxWidth={'sm'}
        open={invoiceTransfer}
        onClose={() => {
          setSendEmails(false);
          setInvoiceTransfer(false);
          setSelectedInvoice(null);
          setJobInvoices({ job_id: null, invoices: [] });
        }}
      >
        <DialogTitle>{t('TRANSFER_EXISTING_INVOICE')}</DialogTitle>
        <DialogContent className='flex flex-row' sx={{ width: 450 }}>
          {invoicesLoading == true ? (
            <CircularLoader />
          ) : invoiceTransfer && jobInvoices?.invoices && jobInvoices?.invoices.length > 0 ? (
            <Autocomplete
              disableListWrap
              clearOnBlur={false}
              freeSolo={false}
              id='invoice-transfer-box'
              value={selectedInvoice}
              onChange={(e, newValue) => {
                //console.log(newValue);
                setSelectedInvoice(newValue);
              }}
              options={jobInvoices?.invoices}
              loading={true}
              sx={{ width: 300, padding: 0 }}
              renderInput={(params) => (
                <TextField {...params} placeholder={t('INVOICE')} sx={{ padding: 0 }} />
              )}
              renderOption={(props, option) => <li {...props}>{option.label}</li>}
            />
          ) : (
            <div className='flex flex-row w-full items-center justify-center align-center'>
              <Typography variant='h4'>{t('NO_INVOICES_FOUND')}</Typography>
            </div>
          )}

          {invoicesLoading == true ? null : invoiceTransfer &&
            jobInvoices?.invoices &&
            jobInvoices?.invoices.length > 0 ? (
            <div className=' flex flex-row pl-16 items-center'>
              <Button variant='contained' sx={{ height: '45px' }} onClick={InvoiceTransfer}>
                <Typography fontWeight={'bold'}>{t('TRANSFER')}</Typography>
              </Button>
            </div>
          ) : null}
        </DialogContent>
        {invoiceTransfer && jobInvoices?.invoices && jobInvoices?.invoices.length > 0 ? (
          <div className='flex flex-row align-center items-center justify-end w-full pb-8 pr-16 text-black'>
            <Checkbox
              className='p-0'
              checked={sendEmails}
              onChange={(e) => {
                setSendEmails(e.target.checked);
              }}
            />
            {t('SEND_UPDATED_INVOICE_TO_CUSTOMER')}
          </div>
        ) : null}
        <DialogActions>
          <Button
            onClick={() => {
              setSendEmails(false);
              setInvoiceTransfer(false);
              setSelectedInvoice(null);
              setJobInvoices({ job_id: null, invoices: [] });
            }}
          >
            {t('CLOSE')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={loadingBar}
        onClose={() => {
          setLoadingBar(false);
        }}
      >
        <FuseLoading />
      </Dialog>

      <Paper className='responsive-loads-tabless'>
        {selected && selected.length > 0 ? (
          <div class='ticket-table-icon'>
            <ReactToPrint
              trigger={() => (
                <ToggleButton aria-label='print'>
                  <img className='w-16' alt='user photo' src='assets/images/icons/print-icon.svg' />
                </ToggleButton>
              )}
              content={() => componentRef.current}
            />
            <div style={{ paddingLeft: 20 }} className='inline-block'>
              <Tooltip title={t('JOB_TRANSFER')} placement='top'>
                <IconButton
                  onClick={() => {
                    //open modal

                    //call function
                    checkJobTransfer();
                  }}
                >
                  {' '}
                  <LowPriorityIcon />
                </IconButton>
              </Tooltip>
            </div>
            <div style={{ paddingLeft: 20 }} className='inline-block'>
              <Tooltip title={t('TRANSFER_TO_EXISTING_INVOICE')} placement='top'>
                <IconButton
                  onClick={() => {
                    //open modal
                    setInvoiceTransfer(true);
                  }}
                >
                  {' '}
                  <ReceiptIcon />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        ) : (
          ''
        )}

        <TableContainer
          style={{ maxWidth: '100%', maxHeight: '600px' }}
          onScroll={onScroll}
          ref={listInnerRef}
        >
          {React.useMemo(() => {
            return (
              <Table stickyHeader aria-label='sticky table'>
                <TableRow>
                  {ticketStatus == 3 ? null : <TableCell padding='checkbox'></TableCell>}
                  <StyledTableCell style={{ top: 57 }}>{t('TICKET_NO')}</StyledTableCell>
                  <StyledTableCell style={{ top: 57 }}>{t('QTY')}.</StyledTableCell>
                  <StyledTableCell style={{ top: 57 }}>{t('MATERIAL')}.</StyledTableCell>
                  <StyledTableCell style={{ top: 57 }}>{t('DRIVER')}.</StyledTableCell>
                  <StyledTableCell style={{ top: 57 }}>{t('TRUCK_NO')}</StyledTableCell>
                  {jobTickets.length > 0 && jobTickets.some((ticket) => !ticket?.commissions) ? (
                    <StyledTableCell style={{ top: 57 }}>{t('TK_START')}.</StyledTableCell>
                  ) : (
                    ''
                  )}

                  {jobTickets.length > 0 && jobTickets.some((ticket) => !ticket?.commissions) ? (
                    <StyledTableCell style={{ top: 57 }}>{t('TK_END')}.</StyledTableCell>
                  ) : (
                    ''
                  )}

                  <StyledTableCell style={{ top: 57 }}>{t('WAIT_TIME')}.</StyledTableCell>

                  <StyledTableCell style={{ top: 57 }}>
                    {ticketStatus == 3 ? t('DELETED_DATE') : t('TICKET_DATE')}
                  </StyledTableCell>

                  {jobTickets.length > 0 && jobTickets.some((ticket) => ticket.scale == true) ? (
                    <StyledTableCell style={{ top: 57 }}>{t('SCALE_TICKET')}.</StyledTableCell>
                  ) : (
                    ''
                  )}

                  <StyledTableCell style={{ top: 57 }}>{t('RECEIVED_BY')}.</StyledTableCell>

                  {ticketStatus == 3 ? (
                    <StyledTableCell style={{ top: 57 }}>{t('REASON')}</StyledTableCell>
                  ) : null}

                  {(ticketStatus == 1 || ticketStatus == 3) && (
                    <StyledTableCell style={{ top: 57 }}>{t('OWNER')}.</StyledTableCell>
                  )}

                  <StyledTableCell style={{ top: 57 }}></StyledTableCell>
                </TableRow>
                <TableBody>
                  {jobTickets.length ? (
                    <>
                      {jobTickets.map((n, i) => {
                        //console.log('jobTickets map n => ', n);
                        const isSelected = isSelectedElement(n.ticket_id);
                        return (
                          <ErrorBoundary>
                            <StyledTableRow key={i}>
                              {ticketStatus == 3 ? null : (
                                <StyledTableCell padding='checkbox'>
                                  <Checkbox
                                    checked={isSelected}
                                    onClick={(event) => handleClick(event, n)}
                                  />
                                </StyledTableCell>
                              )}

                              <StyledTableCell
                                onClick={() => getSingleTicketData(n)}
                                className='p-4 md:p-16 truncate'
                                component='th'
                                scope='row'
                                data-headtext={t('TICKET_NO')}
                              >
                                <b>{n.tk_no}</b>
                              </StyledTableCell>

                              <StyledTableCell
                                onClick={() => getSingleTicketData(n)}
                                className='p-3 md:p-12'
                                component='th'
                                scope='row'
                                data-headtext={t('QTY')}
                              >
                                <b>
                                  {n.tk_qty} {n.unit_name}
                                </b>
                              </StyledTableCell>

                              <StyledTableCell
                                onClick={() => getSingleTicketData(n)}
                                className='p-4 md:p-16'
                                component='th'
                                scope='row'
                                data-headtext={t('MATERIAL')}
                              >
                                <b>{n.name}</b>
                              </StyledTableCell>

                              <StyledTableCell
                                onClick={() => getSingleTicketData(n)}
                                className='p-4 md:p-16'
                                component='th'
                                scope='row'
                                data-headtext={t('DRIVER')}
                              >
                                <b>
                                  {n.user_fname} {n.user_lname}
                                </b>
                              </StyledTableCell>

                              <StyledTableCell
                                onClick={() => getSingleTicketData(n)}
                                className='p-4 md:p-16'
                                component='th'
                                scope='row'
                                data-headtext={t('TRUCK_NO')}
                              >
                                <b>{n.t_no_truck}</b>
                              </StyledTableCell>

                              {jobTickets.length > 0 &&
                              jobTickets.some((ticket) => !ticket?.commissions) ? (
                                <StyledTableCell
                                  onClick={() => getSingleTicketData(n)}
                                  className='p-4 md:p-16'
                                  component='th'
                                  scope='row'
                                  data-headtext={t('TK_START')}
                                >
                                  {/* <b>{n.tk_start}</b> */}
                                  {getFormatedTime(n.tk_start)}
                                </StyledTableCell>
                              ) : (
                                ''
                              )}

                              {jobTickets.length > 0 &&
                              jobTickets.some((ticket) => !ticket?.commissions) ? (
                                <StyledTableCell
                                  onClick={() => getSingleTicketData(n)}
                                  className='p-4 md:p-16'
                                  component='th'
                                  scope='row'
                                  data-headtext={t('TK_END')}
                                >
                                  {/* {n.tk_end} */}
                                  {getFormatedTime(n.tk_end)}
                                </StyledTableCell>
                              ) : (
                                ''
                              )}

                              <StyledTableCell
                                onClick={() => getSingleTicketData(n)}
                                className='p-4 md:p-16'
                                component='th'
                                scope='row'
                                data-headtext={t('WAIT_TIME')}
                              >
                                {n.wait_time ? (
                                  <PauseCircleOutlineIcon
                                    sx={{ color: red[600] }}
                                  ></PauseCircleOutlineIcon>
                                ) : (
                                  <PauseCircleOutlineIcon
                                    sx={{ color: grey[600] }}
                                  ></PauseCircleOutlineIcon>
                                )}
                              </StyledTableCell>

                              <StyledTableCell
                                onClick={() => getSingleTicketData(n)}
                                className='p-4 md:p-16'
                                component='th'
                                scope='row'
                                data-headtext={
                                  ticketStatus == 3 ? t('DELETED_DATE') : t('TICKET_DATE')
                                }
                              >
                                {(() => {
                                  const value = ticketStatus == 3 ? n.date_updated : n.date_created;
                                  return moment(value).isValid() ? moment(value).format('LLL') : value;
                                })()}
                              </StyledTableCell>

                              {jobTickets.length > 0 &&
                              jobTickets.some((ticket) => ticket.scale == true) ? (
                                <StyledTableCell
                                  className='p-4 md:p-16 text-center items-center justify-center'
                                  component='th'
                                  scope='row'
                                  data-headtext={t('SCALE_TICKET_IMAGE')}
                                >
                                  {n.tk_scale_no ? (
                                    <>
                                      {Array.isArray(n.scale_ticket_image) &&
                                      n?.scale_ticket_image?.length ? (
                                        <>
                                          <ScaleImageThumbnail
                                            scaleImages={n}
                                            onClick={() => {
                                              setScaleImages(n);
                                              setOpenScaleImageDialog(true);
                                              ButtonLog({
                                                button_name: 'ticket_scale_image',
                                                type: 'ticket',
                                                info: `viewing scale image for ticket id ${n.tk_id}`,
                                              });
                                            }}
                                          />
                                          {n?.tk_scale_no && (
                                            <Typography mt={2}>#{n.tk_scale_no}</Typography>
                                          )}
                                        </>
                                      ) : n.scale_ticket_image ? (
                                        <Typography>#{n.tk_scale_no}</Typography>
                                      ) : (
                                        <span className='loading-img-list animate-pulse inline-block w-32 h-32 bg-gray-200'>
                                          {t('N_SLASH_A')}
                                        </span>
                                      )}
                                    </>
                                  ) : (
                                    <span className='loading-img-list animate-pulse inline-block w-32 h-32 bg-gray-200'>
                                      {t('N_SLASH_A')}
                                    </span>
                                  )}
                                </StyledTableCell>
                              ) : (
                                ''
                              )}

                              <StyledTableCell
                                onClick={() => getSingleTicketData(n)}
                                className='p-4 md:p-16'
                                component='th'
                                scope='row'
                                data-headtext={t('RECEIVED_BY')}
                              >
                                <div className='flex flex-row items-center align-center'>
                                  {n.tk_receievedby_mediaurl ? (
                                    <img
                                      width='50'
                                      height='70'
                                      src={
                                        n?.tk_receievedby_mediaurl?.includes('http')
                                          ? n.tk_receievedby_mediaurl
                                          : `${constants.URLLOCAL}/aws/signed?image=${n.tk_receievedby_mediaurl}`
                                      }
                                    />
                                  ) : (
                                    <p>{t('NO_IMAGE')}</p>
                                  )}
                                  <Typography>{n.l_initial}</Typography>
                                </div>
                              </StyledTableCell>

                              {ticketStatus == 3 && (
                                <StyledTableCell
                                  className='p-4 md:p-16'
                                  component='th'
                                  scope='row'
                                  data-headtext={t('REASON')}
                                >
                                  {<Typography>{n.reason}</Typography>}
                                </StyledTableCell>
                              )}

                              {(ticketStatus == 1 || ticketStatus == 3) && (
                                <StyledTableCell
                                  onClick={() => getSingleTicketData(n)}
                                  className='p-4 md:p-16'
                                  component='th'
                                  scope='row'
                                  data-headtext={t('TICKET_TYPE')}
                                >
                                  {<Typography>{n.ticket_owner_type}</Typography>}
                                </StyledTableCell>
                              )}

                              <StyledTableCell className='p-0 '>
                                {ticketStatus != 3 &&
                                n.job_type == 'OG' &&
                                n.ticket_owner_type == 'SUB' ? (
                                  <Chip
                                    onClick={(event) => open_reqtransfer(n)}
                                    /* label="Single Transfer Request" */
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      background: 'none',
                                    }}
                                    icon={
                                      <Icon
                                        style={{
                                          color: '#edca33',
                                          display: 'flex',
                                          alignItems: 'center',
                                        }}
                                      >
                                        <LowPriorityIcon sx={{ fontSize: '18px' }} />
                                      </Icon>
                                    }
                                  />
                                ) : null}
                                {ticketStatus == 3 ? null : renderEditButton(n)}
                                {ticketStatus == 3 ? null : renderDeleteButton(n)}
                                {/*renderTicketAudit(n)*/}
                              </StyledTableCell>
                            </StyledTableRow>
                          </ErrorBoundary>
                        );
                      })}
                    </>
                  ) : null}
                </TableBody>
              </Table>
            );
          }, [jobTickets, search, jobTransfer, jobs, prop_data, jobPage, ticketStatus, selected])}
          {!loading ? (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { delay: 0.1 } }}
              className='flex flex-1 items-center justify-center h-full moble-content'
            >
              <Typography color='textSecondary' variant='h5'>
                {t('NO_MORE_DATA')}
              </Typography>
            </motion.div>
          ) : null}
        </TableContainer>
        {loading && <LinearProgress />}
      </Paper>

      <TicketPopup
        getTicketAudit={getTicketAudit}
        open={modalShow}
        handleclose={handleClose}
        data={ticketPop}
        logo={logoUrl}
        newLoc={setjDestion}
        auditLoading={auditLoading}
        ticketAuditData={ticketAuditData}
      />

      <div style={{ display: 'none' }}>
        <TicketMultiplePrint
          ref={componentRef}
          dataList={selected}
          compLogo={compLogo}
          newLoc={setjDestion}
        />
      </div>

      <TicketScaleImageUploader
        user={user}
        handleAddEditScaleImage={handleAddEditScaleImage}
        open={openScaleImageUploader}
        setOpen={setOpenScaleImageUploader}
      />

      {/* modal para eliminar el ticket */}
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            backgroundColor: 'whitesmoke',
            boxShadow: 'none',
            width: '35%',
          },
        }}
        classes={{
          paper: 'm-24',
        }}
        maxWidth={'md'}
      >
        <DialogContent>
          {/* using tk_id find in jobTickets a record with the property tk_id */}
          <div className='flex flex-1'>
            <Icon
              style={{
                color: 'red',
                fontSize: '2.5rem',
                paddingRight: '10%',
                paddingBottom: '10%',
              }}
            >
              warning_amber
            </Icon>
            {(() => {
              const ticket = jobTickets.find((ticket) => ticket.tk_id === tk_id);
              if (ticket?.ogInvoiceBlanace == '$0.00') {
                return (
                  <DialogContentText
                    style={{ fontSize: '18px', fontWeight: 'bold', paddingBottom: '2%' }}
                    color={'#0e0e0e'}
                  >
                    {t(
                      'THIS_TICKET_WILL_BE_REMOVED_FROM_CUSTOMER_BALANCE_BUT_WILL_STILL_APPEAR_IN_OOP'
                    )}
                  </DialogContentText>
                );
              } else {
                return (
                  <DialogContentText
                    style={{ fontSize: '18px', fontWeight: 'bold', paddingBottom: '2%' }}
                    color={'#0e0e0e'}
                  >
                    {t('ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TICKET')}
                  </DialogContentText>
                );
              }
            })()}
          </div>

          <DialogContentText style={{ paddingLeft: '10%' }} color={'#0e0e0e'}>
            {t('THIS_ACTION_IS_PERMANENT_AND_CANNOT_BE_UNDONE')}
          </DialogContentText>
          <DialogContentText style={{ paddingLeft: '10%' }} color={'#0e0e0e'}>
            {t('THE_TICKET_WILL_BE_ELIMINATED_FROM_ALL_RECORDS')}
          </DialogContentText>
          <br></br>
          <DialogContentText color={'#0e0e0e'}>
            {t('REASON_FOR_DELETION_OPTIONAL')}
          </DialogContentText>

          <Controller
            name='reason'
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                className='mt-8 mb-16 '
                id='reason'
                variant='outlined'
                fullWidth
                multiline
                rows={3}
                style={{ backgroundColor: '#FFFFFF' }}
              />
            )}
          />

          <div className='flex flex-row align-center items-center justify-end w-full pb-8 text-black'>
            <Checkbox
              className='p-0'
              value={sendEmails}
              onChange={(e) => {
                setSendEmails(e.target.checked);
              }}
            />
            {t('SEND_UPDATED_INVOICE_TO_CUSTOMER')}
          </div>

          <div className='flex mx-6' style={{ justifyContent: 'end' }}>
            <Button
              style={{ backgroundColor: 'white', border: '1px solid #E2E1E5', marginRight: '2%' }}
              onClick={handleClose}
            >
              <Typography color={'black'}>{t('CANCEL')}</Typography>
            </Button>
            <Button
              style={{ backgroundColor: '#b71c1c', marginLeft: '2%', border: '1px solid #E2E1E5' }}
              onClick={deleteTicket}
            >
              <Typography color={'white'}>{t('YES_DELETE_TICKET')}</Typography>
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* modal para editar el ticket here*/}
      <Dialog
        open={openedit}
        onClose={updateTicketLoading ? undefined : handleCloseEdit}
        disableEscapeKeyDown={updateTicketLoading}
      >
        {truckDriverLoading ? (
          <FuseLoading />
        ) : (
          <>
            <AppBar style={{ backgroundColor: '#edca33' }} position='static' elevation={0}>
              <Toolbar className='flex w-full' style={{ justifyContent: 'space-between', gap: 8 }}>
                <Box display='flex' alignItems='center' flexWrap='wrap' style={{ gap: 10, minWidth: 0, flex: 1 }}>
                  <Typography
                    variant='subType1'
                    color='black'
                    style={{ fontWeight: 'bold', fontSize: '20px', whiteSpace: 'nowrap' }}
                  >
                    {t('EDIT_TICKET_NO')}: {tk_No}
                  </Typography>
                  {lastEditBannerVisible &&
                    lastEditPreview?.needs_correction &&
                    (lastEditPreview.changes || []).length > 0 && (
                      <Box
                        display='flex'
                        alignItems='center'
                        style={{
                          color: '#5c3b00',
                          backgroundColor: 'rgba(255,255,255,0.55)',
                          borderRadius: 4,
                          padding: '2px 4px 2px 8px',
                          gap: 2,
                          maxWidth: '100%',
                        }}
                      >
                        <Typography
                          variant='body2'
                          style={{
                            fontWeight: 600,
                            fontSize: 12,
                            lineHeight: 1.3,
                          }}
                        >
                          {i18n.language === 'es'
                            ? 'Valor actual no sincronizado con última edición'
                            : 'Current value not synced with last edit'}
                        </Typography>
                        <IconButton
                          size='small'
                          onClick={dismissLastEditCorrection}
                          style={{ padding: 2, color: '#5c3b00' }}
                          title={i18n.language === 'es' ? 'Descartar cambio' : 'Dismiss change'}
                        >
                          <Icon style={{ fontSize: 16 }}>close</Icon>
                        </IconButton>
                      </Box>
                    )}
                </Box>
                <Tooltip
                  title={
                    i18n.language === 'es'
                      ? 'Recuperar último valor editado'
                      : 'Recover last edited values'
                  }
                >
                  <IconButton
                    onClick={openLastEditCorrectionPreview}
                    disabled={lastEditPreviewLoading}
                    style={{
                      color: '#000',
                      backgroundColor: 'rgba(0,0,0,0.08)',
                      width: 44,
                      height: 44,
                    }}
                  >
                    <Icon style={{ fontSize: 28 }}>history</Icon>
                  </IconButton>
                </Tooltip>
              </Toolbar>
            </AppBar>

            <style jsx='true'>{`
              .MuiOutlinedInput-root.MuiInputBase-root {
                background: #fff !important;
                border: 0px solid #e2e1e5 !important;
                padding: 6px 9px !important;
              }
              .muiltr-qdcpq3-MuiButtonBase-root-MuiCheckbox-root {
                padding-top: 3.5px !important;
                padding-right: 0px !important;
                padding-left: 4.5px !important;
              }
              .muiltr-1i4vc5v-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
                padding: 4px 17px !important;
              }
              .muiltr-1s8wnf5-MuiInputBase-input-MuiOutlinedInput-input {
                padding-bottom: 8px !important;
                padding-top: 3px !important;
              }
              #mui-component-select-tk_status {
                padding-top: 1px !important;
              }
              [role='dialog'] {
                max-width: 710px !important;
              }
            `}</style>

            <DialogContent>
              <div className='flex mx-6'>
                <div style={{ flex: 1 }}>
                  <label style={{ paddingLeft: '10px' }} className='font-Regular text-15 mb-0'>
                    {t('QTY')}
                  </label>
                  <Controller
                    name='tk_qty'
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className='mt-0 mb-16 mx-2'
                        id='tk_qty'
                        variant='outlined'
                        fullWidth
                        type={'text'}
                        inputProps={{
                          inputMode: 'decimal',
                          pattern: '^[0-9]*\\.?[0-9]*$',
                          style: { padding: '0px', borderBottom: '1px solid #E2E1E5' },
                        }}
                        onChange={(e) => {
                          const value = e.target.value;
                          // Only allow numbers and a single decimal point
                          if (/^[0-9]*\.?[0-9]*$/.test(value)) {
                            field.onChange(value);
                          } else {
                            _showMessage(t('ONLY_NUMBER_AND_A_DECIMAL_ARE_ALLOWED'), 'error');
                          }
                        }}
                      />
                    )}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ paddingLeft: '10px' }} className='font-Regular text-15 mb-0'>
                    {t('SCALE_NO')}
                  </label>
                  <Controller
                    name='tk_scale_no'
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className='mt-0 mb-16 mx-2'
                        id='tk_scale_no'
                        variant='outlined'
                        fullWidth
                        type={'text'}
                        inputProps={{
                          inputMode: 'decimal',
                          pattern: '^[0-9]*\\.?[0-9]*$',
                          style: { padding: '0px', borderBottom: '1px solid #E2E1E5' },
                        }}
                        onChange={(e) => {
                          const value = e.target.value;
                          // Only allow numbers and a single decimal point
                          if (/^[0-9]*\.?[0-9]*$/.test(value)) {
                            field.onChange(value);
                          } else {
                            _showMessage(t('ONLY_NUMBER_AND_A_DECIMAL_ARE_ALLOWED'), 'error');
                          }
                        }}
                      />
                    )}
                  />
                </div>
              </div>

              {/**  hauling invoice rate
               * hauiling cost rate
               * material invoice rate
               * material cost rate
               * wait time rate
               * wait time cost
               * employee rate
               * employee cost
               */}
              {/**hauling invoice */}
              <div className='flex mx-6'>
                <div style={{ flex: 1 }}>
                  <label style={{ paddingLeft: '10px' }} className='font-Regular text-15 mb-0'>
                    {t('HAULING_INVOICE_RATE')}
                  </label>
                  <Controller
                    name='tk_rate'
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        disabled={editingTicket?.job_type == 'sub' ? true : false}
                        className='mt-0 mb-16 mx-2'
                        id='tk_rate'
                        variant='outlined'
                        fullWidth
                        type={'text'}
                        inputProps={{
                          inputMode: 'decimal',
                          pattern: '^[0-9]*\\.?[0-9]*$',
                          style: { padding: '0px', borderBottom: '1px solid #E2E1E5' },
                        }}
                        onChange={(e) => {
                          const value = e.target.value;
                          // Only allow numbers and a single decimal point
                          if (/^[0-9]*\.?[0-9]*$/.test(value)) {
                            field.onChange(value);
                          } else {
                            _showMessage(t('ONLY_NUMBER_AND_A_DECIMAL_ARE_ALLOWED'), 'error');
                          }
                        }}
                        InputProps={{
                          startAdornment: (
                            <span style={{ marginRight: 4, alignItems: 'center' }}>$</span>
                          ),
                        }}
                      />
                    )}
                  />
                </div>

                <div style={{ flex: 1 }}>
                  <label style={{ paddingLeft: '10px' }} className='font-Regular text-15 mb-0'>
                    {t('HAULING_TICKET_CREDIT')}
                  </label>
                  <Controller
                    name='ticket_cr'
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        disabled={true}
                        className='mt-0 mb-16 mx-2'
                        id='ticket_cr'
                        variant='outlined'
                        fullWidth
                        inputProps={{
                          style: { padding: '0px', borderBottom: '1px solid #E2E1E5' },
                        }}
                      />
                    )}
                  />
                </div>
              </div>

              {/**hauling cost */}
              <div className='flex mx-6'>
                <div style={{ flex: 1 }}>
                  <label style={{ paddingLeft: '10px' }} className='font-Regular text-15 mb-0'>
                    {t('HAULING_COST_RATE')}
                  </label>
                  <Controller
                    name='tk_cost'
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className='mt-0 mb-16 mx-2'
                        id='tk_cost'
                        variant='outlined'
                        fullWidth
                        type={'text'}
                        inputProps={{
                          inputMode: 'decimal',
                          pattern: '^[0-9]*\\.?[0-9]*$',
                          style: { padding: '0px', borderBottom: '1px solid #E2E1E5' },
                        }}
                        onChange={(e) => {
                          const value = e.target.value;
                          // Only allow numbers and a single decimal point
                          if (/^[0-9]*\.?[0-9]*$/.test(value)) {
                            field.onChange(value);
                          } else {
                            _showMessage(t('ONLY_NUMBER_AND_A_DECIMAL_ARE_ALLOWED'), 'error');
                          }
                        }}
                        InputProps={{
                          startAdornment: (
                            <span style={{ marginRight: 4, alignItems: 'center' }}>$</span>
                          ),
                        }}
                      />
                    )}
                  />
                </div>

                <div style={{ flex: 1 }}>
                  <label style={{ paddingLeft: '10px' }} className='font-Regular text-15 mb-0'>
                    {t('HAULING_TICKET_COST')}
                  </label>
                  <Controller
                    name='hauling_cost'
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        disabled={true}
                        className='mt-0 mb-16 mx-2'
                        id='hauling_cost'
                        variant='outlined'
                        fullWidth
                        inputProps={{
                          style: { padding: '0px', borderBottom: '1px solid #E2E1E5' },
                          startAdornment: (
                            <span style={{ marginRight: 4, alignItems: 'center' }}>$</span>
                          ),
                        }}
                      />
                    )}
                  />
                </div>
              </div>

              {/**material invoice */}
              {editingTicket?.material_broker == true && editingTicket?.job_type != 'sub' ? (
                <div className='flex mx-6'>
                  <div style={{ flex: 1 }}>
                    <label style={{ paddingLeft: '10px' }} className='font-Regular text-15 mb-0'>
                      {t('MATERIAL_INVOICE_RATE')}
                    </label>
                    <Controller
                      name='tk_mat_rate'
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          className='mt-0 mb-16 mx-2'
                          id='tk_mat_rate'
                          variant='outlined'
                          fullWidth
                          type={'text'}
                          inputProps={{
                            inputMode: 'decimal',
                            pattern: '^[0-9]*\\.?[0-9]*$',
                            style: { padding: '0px', borderBottom: '1px solid #E2E1E5' },
                          }}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Only allow numbers and a single decimal point
                            if (/^[0-9]*\.?[0-9]*$/.test(value)) {
                              field.onChange(value);
                            } else {
                              _showMessage(t('ONLY_NUMBER_AND_A_DECIMAL_ARE_ALLOWED'), 'error');
                            }
                          }}
                          InputProps={{
                            startAdornment: (
                              <span style={{ marginRight: 4, alignItems: 'center' }}>$</span>
                            ),
                          }}
                        />
                      )}
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <label style={{ paddingLeft: '10px' }} className='font-Regular text-15 mb-0'>
                      {t('MATERIAL_TICKET_CREDIT')}
                    </label>
                    <Controller
                      name='material_cr'
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          disabled={true}
                          className='mt-0 mb-16 mx-2'
                          id='material_cr'
                          variant='outlined'
                          fullWidth
                          inputProps={{
                            style: { padding: '0px', borderBottom: '1px solid #E2E1E5' },
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              ) : null}

              {/**material cost */}
              {editingTicket?.material_broker == true && editingTicket?.job_type != 'sub' ? (
                <div className='flex mx-6'>
                  <div style={{ flex: 1 }}>
                    <label style={{ paddingLeft: '10px' }} className='font-Regular text-15 mb-0'>
                      {t('MATERIAL_COST_RATE')}
                    </label>
                    <Controller
                      name='tk_mat_cost'
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          className='mt-0 mb-16 mx-2'
                          id='tk_mat_cost'
                          variant='outlined'
                          fullWidth
                          type={'text'}
                          inputProps={{
                            inputMode: 'decimal',
                            pattern: '^[0-9]*\\.?[0-9]*$',
                            style: { padding: '0px', borderBottom: '1px solid #E2E1E5' },
                          }}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Only allow numbers and a single decimal point
                            if (/^[0-9]*\.?[0-9]*$/.test(value)) {
                              field.onChange(value);
                            } else {
                              _showMessage(t('ONLY_NUMBER_AND_A_DECIMAL_ARE_ALLOWED'), 'error');
                            }
                          }}
                          InputProps={{
                            startAdornment: (
                              <span style={{ marginRight: 4, alignItems: 'center' }}>$</span>
                            ),
                          }}
                        />
                      )}
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <label style={{ paddingLeft: '10px' }} className='font-Regular text-15 mb-0'>
                      {t('MATERIAL_TICKET_COST')}
                    </label>
                    <Controller
                      name='material_dr'
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          disabled={true}
                          className='mt-0 mb-16 mx-2'
                          id='material_dr'
                          variant='outlined'
                          fullWidth
                          inputProps={{
                            style: { padding: '0px', borderBottom: '1px solid #E2E1E5' },
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              ) : null}

              {/**wait time */}
              {editingTicket?.tk_type == 1 ||
              editingTicket?.tk_type == 2 ||
              (tkwaitstart && tkwaitstart.length > 0) ? (
                <div className='flex mx-6' style={{ alignItems: 'flex-end' }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ paddingLeft: '10px' }} className='font-Regular text-15 mb-0'>
                      {t('WAIT_RATE')}
                    </label>
                    <Controller
                      name='tk_wait_rate'
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          className='mt-0 mb-16 mx-2'
                          id='tk_wait_rate'
                          variant='outlined'
                          fullWidth
                          type={'text'}
                          inputProps={{
                            inputMode: 'decimal',
                            pattern: '^[0-9]*\\.?[0-9]*$',
                            style: { padding: '0px', borderBottom: '1px solid #E2E1E5' },
                          }}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Only allow numbers and a single decimal point
                            if (/^[0-9]*\.?[0-9]*$/.test(value)) {
                              field.onChange(value);
                              fillWaitPreview(
                                getValues('tk_wait_start'),
                                getValues('tk_wait_end'),
                                value
                              );
                            } else {
                              _showMessage(t('ONLY_NUMBER_AND_A_DECIMAL_ARE_ALLOWED'), 'error');
                            }
                          }}
                          InputProps={{
                            startAdornment: (
                              <span style={{ marginRight: 4, alignItems: 'center' }}>$</span>
                            ),
                          }}
                        />
                      )}
                    />
                  </div>

                  <div style={{ flex: 1, display: 'flex', alignItems: 'flex-end' }}>
                    <div style={{ flex: 1 }}>
                      <label style={{ paddingLeft: '10px' }} className='font-Regular text-15 mb-0'>
                        {t('WAIT_COST')}
                      </label>
                      <Controller
                        name='wait_cr'
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            disabled={true}
                            className='mt-0 mb-16 mx-2'
                            id='wait_cr'
                            variant='outlined'
                            fullWidth
                            inputProps={{
                              style: { padding: '0px', borderBottom: '1px solid #E2E1E5' },
                            }}
                          />
                        )}
                      />
                    </div>
                    {tkwaitstart && tkwaitstart.length > 0 ? (
                      <Checkbox
                        checked={tkwaitstart.every((_, i) => deleteWaitTime.includes(i))}
                        onChange={(e) => {
                          e.stopPropagation();
                          if (e.target.checked) {
                            setDeleteWaitTime(tkwaitstart.map((_, i) => i));
                          } else {
                            setDeleteWaitTime([]);
                          }
                        }}
                        icon={<DeleteIcon />}
                        checkedIcon={<DeleteIcon style={{ color: 'red' }} />}
                        style={{ marginBottom: 10, marginRight: 4 }}
                        inputProps={{ 'aria-label': t('WAIT_TIME_WILL_BE_DELETED_MESSAGE') }}
                      />
                    ) : null}
                  </div>
                </div>
              ) : null}

              {/**employee rate */}
              {editingTicket?.ticket_owner_type == 'EMP' ? (
                <div className='flex mx-6'>
                  <div style={{ flex: 1 }}>
                    <label style={{ paddingLeft: '10px' }} className='font-Regular text-15 mb-0'>
                      {t('EMPLOYEE_RATE')}
                    </label>
                    <Controller
                      name='tk_pay'
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          className='mt-0 mb-16 mx-2'
                          id='tk_pay'
                          variant='outlined'
                          fullWidth
                          type={'text'}
                          inputProps={{
                            inputMode: 'decimal',
                            pattern: '^[0-9]*\\.?[0-9]*$',
                            style: { padding: '0px', borderBottom: '1px solid #E2E1E5' },
                          }}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Only allow numbers and a single decimal point
                            if (/^[0-9]*\.?[0-9]*$/.test(value)) {
                              field.onChange(value);
                            } else {
                              _showMessage(t('ONLY_NUMBER_AND_A_DECIMAL_ARE_ALLOWED'), 'error');
                            }
                          }}
                          InputProps={{
                            startAdornment: (
                              <span style={{ marginRight: 4, alignItems: 'center' }}>
                                {editingTicket?.commissions ? '%' : '$'}
                              </span>
                            ),
                          }}
                        />
                      )}
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <label style={{ paddingLeft: '10px' }} className='font-Regular text-15 mb-0'>
                      {t('EMPLOYEE_COST')}
                    </label>
                    <Controller
                      name='employee_ticket_cost'
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          disabled={true}
                          className='mt-0 mb-16 mx-2'
                          id='employee_ticket_cost'
                          variant='outlined'
                          fullWidth
                          value={
                            editingTicket?.commissions &&
                            (editingTicket?.tk_type == 1 ||
                              editingTicket?.tk_type == 2 ||
                              (tkwaitstart && tkwaitstart.length > 0))
                              ? employeeCostExcludingWait(
                                  field.value,
                                  editingTicket?.wait_cr,
                                  editingTicket?.tk_pay
                                ).toFixed(2)
                              : field.value
                          }
                          inputProps={{
                            style: { padding: '0px', borderBottom: '1px solid #E2E1E5' },
                          }}
                          InputProps={{
                            startAdornment: (
                              <span style={{ marginRight: 4, alignItems: 'center' }}>$</span>
                            ),
                          }}
                        />
                      )}
                    />
                  </div>
                  {editingTicket?.commissions &&
                  (editingTicket?.tk_type == 1 ||
                    editingTicket?.tk_type == 2 ||
                    (tkwaitstart && tkwaitstart.length > 0)) ? (
                    <div style={{ flex: 1 }}>
                      <label style={{ paddingLeft: '10px' }} className='font-Regular text-15 mb-0'>
                        {t('WAIT_VALUE', {
                          defaultValue: i18n.language === 'en' ? 'Wait Value' : 'Valor de Espera',
                        })}
                      </label>
                      <TextField
                        disabled={true}
                        className='mt-0 mb-16 mx-2'
                        id='wait_value'
                        variant='outlined'
                        fullWidth
                        value={driverWaitCommission(
                          activeWaitCost(
                            tkwaitstart,
                            tkwaitend,
                            watchedWaitRate,
                            watchedWaitCr,
                            deleteWaitTime
                          ),
                          watchedTkPay
                        ).toFixed(2)}
                        inputProps={{
                          style: { padding: '0px', borderBottom: '1px solid #E2E1E5' },
                        }}
                        InputProps={{
                          startAdornment: (
                            <span style={{ marginRight: 4, alignItems: 'center' }}>$</span>
                          ),
                        }}
                      />
                    </div>
                  ) : null}
                </div>
              ) : null}

              {/* Validation for ticket start and ticket end */}
              <div className='flex mx-6'>
                <div style={{ flex: 1 }}>
                  <label style={{ paddingLeft: '10px' }} className='font-Regular text-15 mb-0'>
                    {t('TICKET_START')} - {t('TICKET_END')}
                  </label>
                  <div
                    className='flex flex-row'
                    style={{ borderBottom: '1px solid #E2E1E5', width: '95%', height: '46.5px' }}
                  >
                    {(tkstartFinal && tkstartFinal.length > 0) ||
                    (tkendFinal && tkendFinal.length > 0) ? (
                      <>
                        <Controller
                          name='tk_start'
                          inputProps={{ style: { padding: '0px' } }}
                          control={control}
                          render={({ field }) => (
                            <>
                              {tkstartFinal.map((inputField, i) => (
                                <div key={inputField}>
                                  <Controller
                                    name='tk_start'
                                    inputProps={{ style: { padding: '0px' } }}
                                    control={control}
                                    render={({ field }) => (
                                      <TimePicker
                                        value={inputField}
                                        inputProps={{ style: { padding: '0px' } }}
                                        onChange={(newValue) => {
                                          let starttime = moment(newValue).format();
                                          handleChangeStart(i, starttime);
                                          setTimeStart(newValue);
                                        }}
                                        renderInput={(_props) => (
                                          <TextField className='mt-0 mb-4 ml-4 mr-15' {..._props} />
                                        )}
                                      />
                                    )}
                                  />
                                </div>
                              ))}
                            </>
                          )}
                        />

                        <Controller
                          name='tk_end'
                          inputProps={{ style: { padding: '0px' } }}
                          control={control}
                          render={({ field }) => (
                            <>
                              {tkendFinal.map((inputField, i) => (
                                <div key={i}>
                                  <Controller
                                    inputProps={{ style: { padding: '0px' } }}
                                    name='tk_end'
                                    control={control}
                                    render={({ field }) => (
                                      <TimePicker
                                        inputProps={{ style: { padding: '0px' } }}
                                        value={inputField}
                                        onChange={(newValue) => {
                                          let endtime = moment(newValue).format();
                                          handleChangeEnd(i, endtime);
                                          setTimeEnd(newValue);
                                        }}
                                        renderInput={(_props) => (
                                          <TextField className='mt-0 mb-4 ml-4 mr-15' {..._props} />
                                        )}
                                      />
                                    )}
                                  />
                                </div>
                              ))}
                            </>
                          )}
                        />
                      </>
                    ) : (
                      <label
                        id='no_data_test'
                        style={{ paddingLeft: '10px', paddingTop: '10px' }}
                        className='font-Regular text-15 mb-0'
                      >
                        {t('NO_DATA_AVAILABLE')}
                      </label>
                    )}
                  </div>
                </div>

                <div style={{ flex: 1 }}>
                  <label style={{ paddingLeft: '10px' }} className='font-Regular text-15 mb-0'>
                    {t('WAIT_START')} - {t('WAIT_END')}
                  </label>
                  <div
                    className='flex flex-row'
                    style={{ borderBottom: '1px solid #E2E1E5', width: '95%', minHeight: '46.5px' }}
                  >
                    {(tkwaitstart && tkwaitstart.length > 0) ||
                    (tkwaitend && tkwaitend.length > 0) ? (
                      <>
                        <Controller
                          name='tk_wait_start'
                          control={control}
                          render={({ field }) => (
                            <>
                              {tkwaitstart.map((inputField, i) => (
                                <div
                                  className='flex flex-row items-center'
                                  key={i}
                                  style={{ marginRight: 8, flexWrap: 'wrap', gap: 4 }}
                                >
                                  <Controller
                                    name={`tk_wait_start[${i}]`}
                                    control={control}
                                    render={({ field }) => (
                                      <DateTimePicker
                                        label={t('WAIT_START')}
                                        value={tkwaitstart[i]}
                                        onChange={(newValue) => {
                                          // Full date+time so user can set ticket-day wait explicitly
                                          const waitstarttime = newValue
                                            ? moment(newValue).format()
                                            : null;
                                          if (!waitstarttime || waitstarttime === 'Invalid date') {
                                            return;
                                          }
                                          handleChangeWaitStart(i, waitstarttime);
                                          setWaitTimeStart(waitstarttime);
                                        }}
                                        renderInput={(_props) => (
                                          <TextField
                                            className='mt-0 mb-0 mx-0'
                                            {..._props}
                                            style={{ minWidth: 180 }}
                                          />
                                        )}
                                      />
                                    )}
                                  />
                                  <span style={{ margin: '0 4px' }}>-</span>
                                  <Controller
                                    name={`tk_wait_end[${i}]`}
                                    control={control}
                                    render={({ field }) => (
                                      <DateTimePicker
                                        label={t('WAIT_END')}
                                        value={tkwaitend[i]}
                                        onChange={(newValue) => {
                                          const waitendtime = newValue
                                            ? moment(newValue).format()
                                            : null;
                                          if (!waitendtime || waitendtime === 'Invalid date') {
                                            return;
                                          }
                                          handleChangeWaitEnd(i, waitendtime);
                                          setWaitTimeEnd(waitendtime);
                                        }}
                                        renderInput={(_props) => (
                                          <TextField
                                            className='mt-0 mb-0 mx-0'
                                            {..._props}
                                            style={{ minWidth: 180 }}
                                          />
                                        )}
                                      />
                                    )}
                                  />
                                  <Checkbox
                                    checked={deleteWaitTime.includes(i)}
                                    onChange={(e) => {
                                      e.stopPropagation();
                                      if (e.target.checked == false) {
                                        setDeleteWaitTime(
                                          deleteWaitTime.filter((item) => item !== i)
                                        );
                                      }
                                      if (e.target.checked == true) {
                                        setDeleteWaitTime([...deleteWaitTime, i]);
                                      }
                                    }}
                                    icon={<DeleteIcon />}
                                    checkedIcon={<DeleteIcon style={{ color: 'red' }} />}
                                    style={{ marginLeft: 4 }}
                                    inputProps={{
                                      'aria-label': t('WAIT_TIME_WILL_BE_DELETED_MESSAGE'),
                                    }}
                                  />
                                </div>
                              ))}
                            </>
                          )}
                        />
                      </>
                    ) : (
                      <>
                        <Button
                          variant='outlined'
                          color='primary'
                          size='small'
                          style={{ marginLeft: 8, marginTop: 8, height: 30 }}
                          onClick={() => {
                            const ticketDay = moment(
                              resolveTicketAnchorDate(editingTicket) ||
                                getValues('tk_datecreated') ||
                                undefined,
                            );
                            const base = ticketDay.isValid() ? ticketDay : moment();
                            const newWaitStart = base.clone().hour(14).minute(0).second(0).millisecond(0).format();
                            const newWaitEnd = base.clone().hour(16).minute(0).second(0).millisecond(0).format();
                            const updatedWaitStart = [newWaitStart];
                            const updatedWaitEnd = [newWaitEnd];
                            setTkwaitstart(updatedWaitStart);
                            setTkwaitend(updatedWaitEnd);
                            setValue('tk_wait_start', updatedWaitStart);
                            setValue('tk_wait_end', updatedWaitEnd);
                            setWaitTimeStart(updatedWaitStart);
                            setWaitTimeEnd(updatedWaitEnd);
                            fillWaitPreview(
                              updatedWaitStart,
                              updatedWaitEnd,
                              getValues('tk_wait_rate'),
                              true
                            );
                          }}
                        >
                          Add Wait Start - Wait End
                        </Button>
                      </>
                    )}
                  </div>
                  {deleteWaitTime.length > 0 ? (
                    <Typography
                      style={{
                        paddingLeft: 10,
                        paddingTop: 6,
                        fontSize: 12,
                        lineHeight: 1.35,
                        color: '#d32f2f',
                      }}
                    >
                      {t('WAIT_TIME_WILL_BE_DELETED_MESSAGE')}
                    </Typography>
                  ) : null}
                </div>
              </div>

              {editingTicket?.scale == true && (
                <div
                  style={{
                    width: '50%',
                    borderBottom: '1px solid #E2E1E5',
                    paddingLeft: '10px',
                    paddingTop: '10px',
                    paddingBottom: '5px',
                  }}
                >
                  <Typography className=' mt-12 text-16 font-700'>
                    {t('TICKET_SCALE_IMAGE')}
                  </Typography>

                  <div
                    style={{ maxWidth: '400px' }}
                    className='items-center justify-center w-full grid grid-cols-3 gap-y-2 gap-x-4'
                  >
                    {editTkScaleImage.map((image, index) => {
                      //console.log('image',image)
                      return (
                        <div
                          className='flex flex-row justify-center align-center items-center'
                          style={{ height: '100%', width: '100%', padding: '0 5px' }}
                        >
                          <Button
                            className='flex flex-row justify-center align-center items-center'
                            onClick={(e) => {
                              e.stopPropagation();
                              window.open(
                                image?.file
                                  ? URL.createObjectURL(image?.file)
                                  : `${constants.URLLOCAL}/aws/signed?image=${image?.key}`,
                                '_blank'
                              );
                            }}
                            sx={{
                              borderRadius: 0,
                              height: '100%',
                              color: 'blue',
                              padding: 0,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <img
                              style={{
                                maxWidth: '100%', // Ensure the image does not exceed the width of the button
                                maxHeight: '100%', // Ensure the image does not exceed the height of the button
                                width: 'auto', // Maintain aspect ratio
                                height: 'auto', // Maintain aspect ratio
                              }}
                              src={
                                image?.file
                                  ? URL.createObjectURL(image?.file)
                                  : `${constants.URLLOCAL}/aws/signed?image=${image?.key}`
                              }
                            />
                          </Button>

                          <div
                            className='flex justify-center align-center items-center'
                            style={{
                              background: '#edca33',
                              border: '1px solid black',
                              height: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <IconButton
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteEditScaleImage(index);
                              }}
                            >
                              <DeleteIcon fontSize='small' />
                            </IconButton>
                          </div>
                        </div>
                      );
                    })}
                    {allowToUploadScaleTicketImage && (
                      <IconButton
                        sx={{
                          padding: 0,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          height: '33px',
                          width: '33px',
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenScaleImageUploader(true);
                        }}
                      >
                        <AddIcon
                          sx={{
                            background: 'black',
                            color: '#edca33',
                            border: 3,
                            borderRadius: 5,
                            borderColor: '#edca33',
                          }}
                          fontSize='large'
                        />
                      </IconButton>
                    )}
                  </div>
                </div>
              )}

              {tickettype == 'EMP' ? (
                <div className='flex mx-6' style={{ height: '68.75px' }}>
                  <FormControl className='mt-8 mb-8' fullWidth>
                    <label style={{ paddingLeft: '10px' }} className='font-Regular text-15 mb-0'>
                      {t('TRUCKS')}:
                    </label>
                    <Controller
                      name='truck_id'
                      control={control}
                      render={({ field }) => (
                        <div style={{ borderBottom: '1px solid #E2E1E5' }}>
                          <Select
                            {...field}
                            variant='outlined'
                            sx={{ height: '100%' }}
                            inputProps={{ style: { padding: '0px' } }}
                            style={{}}
                          >
                            {trucks
                              ? trucks.map((field) => (
                                  <MenuItem
                                    value={field.idx_trucks_p}
                                    key={field.idx_trucks_p}
                                    inputProps={{ style: { padding: '0px' } }}
                                    style={{ padding: '0px' }}
                                  >
                                    No. {field.t_no_truck}
                                  </MenuItem>
                                ))
                              : []}
                          </Select>
                        </div>
                      )}
                    />
                  </FormControl>

                  <FormControl className='mt-0 mb-0' fullWidth>
                    <label style={{ paddingLeft: '10px' }} className='font-Regular text-15 mb-0'>
                      {t('DRIVER')}:
                    </label>
                    <Controller
                      name='driver_id'
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <Autocomplete
                          options={driverOptions}
                          getOptionLabel={(option) => option?.label || ''}
                          isOptionEqualToValue={(option, val) => option.value === val.value}
                          value={driverOptions.find((option) => option.value === value) || null}
                          onChange={(_, newValue) => {
                            onChange(newValue ? newValue.value : null);
                          }}
                          sx={{
                            '& .MuiInputBase-root': { height: '65px' },
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder='Driver'
                              sx={{ padding: 0 }}
                              inputProps={{
                                ...params.inputProps,
                                style: { borderBottom: '1px solid #E2E1E5' },
                              }}
                            />
                          )}
                        />
                      )}
                    />
                  </FormControl>
                </div>
              ) : null}

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  marginTop: '8px',
                }}
              >
                <FormControl className='mt-8 mb-12' fullWidth>
                  <label style={{ paddingLeft: '10px' }} className='font-Regular text-15 mb-0'>
                    {t('STATUS')}:
                  </label>
                  <Controller
                    name='tk_status'
                    control={control}
                    render={({ field }) => (
                      <div style={{ borderBottom: '1px solid #E2E1E5' }}>
                        <Select
                          {...field}
                          variant='outlined'
                          style={{ paddingTop: '1px !important' }}
                          inputProps={{ style: { paddingTop: '1px !important' } }}
                        >
                          <MenuItem key='0' value={'0'}>
                            {t('PROGRESS')}
                          </MenuItem>
                          <MenuItem key='2' value={'2'}>
                            {t('DELAYED')}
                          </MenuItem>
                          <MenuItem key='1' value={'1'}>
                            {t('COMPLETED')}
                          </MenuItem>
                        </Select>
                      </div>
                    )}
                  />
                </FormControl>

                <FormControl className='mt-8 mb-12' fullWidth>
                  <label style={{ paddingLeft: '10px' }} className='font-Regular text-15 mb-0'>
                    {t('TICKET_CREATED')}:
                  </label>
                  <Controller
                    name='tk_datecreated'
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <DateTimePicker
                        value={value}
                        onChange={onChange}
                        fullWidth
                        inputProps={{ style: { borderBottom: '1px solid #E2E1E5' } }}
                        renderInput={(_props) => <TextField fullWidth {..._props} />}
                      />
                    )}
                  />
                </FormControl>
              </div>

              <div className='flex flex-row align-center items-center justify-end w-full pb-8'>
                <Checkbox
                  className='p-0'
                  value={sendEmails}
                  onChange={(e) => {
                    setSendEmails(e.target.checked);
                  }}
                />
                {t('SEND_UPDATED_INVOICE_TO_CUSTOMER')}
              </div>

              <div className='flex mx-6 mb-16 items-center'>
                {jobBillingHistoryLoading ? (
                  <Typography color='textSecondary'>
                    {i18n.language === 'es' ? 'Cargando cambios…' : 'Loading changes…'}
                  </Typography>
                ) : jobBillingHistory.length === 0 ? (
                  <Typography color='textSecondary'>
                    {i18n.language === 'es' ? 'No hay cambios disponibles' : 'No changes available'}
                  </Typography>
                ) : (
                  <>
                    <FormControl variant='outlined' size='small' style={{ minWidth: 280 }}>
                      <label style={{ paddingLeft: '10px' }} className='font-Regular text-15 mb-0'>
                        {i18n.language === 'es' ? 'Valores según cambio del job' : 'Values based on job change'}
                      </label>
                      <Select
                        value={recalcWith || ''}
                        onChange={(e) => handleRecalcOptionChange(e.target.value)}
                        displayEmpty
                        style={{ marginTop: 8, background: '#fff' }}
                        disabled={recalcLoading}
                      >
                        <MenuItem value=''>
                          <Typography variant='body2' color='textSecondary'>
                            {i18n.language === 'es' ? 'Selecciona un cambio…' : 'Select a change…'}
                          </Typography>
                        </MenuItem>
                        {jobBillingHistory.map((e) => {
                          const toNumber = (v) => {
                            if (v == null || v === '') return null;
                            const n = Number(String(v).replace(/[^0-9.-]/g, ''));
                            return Number.isFinite(n) ? n : null;
                          };
                          const dateStr = e.update_date ? moment(e.update_date).format('YYYY-MM-DD HH:mm') : `Entry ${e.entry_id}`;
                          const retroStr = e.retroactive
                            ? i18n.language === 'es'
                              ? 'Sí'
                              : 'Yes'
                            : i18n.language === 'es'
                            ? 'En adelante'
                            : 'Going forward';
                          const oldB = toNumber(e.oldbill_per_unit);
                          const newB = toNumber(e.newbill_per_unit);
                          const oldCostRate = toNumber(
                            e.oldcost_per_unit ?? e.old_cost_per_unit ?? e.oldCostPerUnit ?? e.old_cost_rate
                          );
                          const newCostRate = toNumber(
                            e.newcost_per_unit ?? e.new_cost_per_unit ?? e.newCostPerUnit ?? e.new_cost_rate
                          );
                          const oldM = toNumber(e.oldmaterial_invoice_rate);
                          const newM = toNumber(e.newmaterial_invoice_rate);
                          const oldMCost = toNumber(e.oldmaterial_cost_rate);
                          const newMCost = toNumber(e.newmaterial_cost_rate);
                          const currentCostRate = toNumber(getValues('tk_cost'));
                          const parts = [];
                          if (oldB != null && newB != null && oldB !== newB) parts.push(`hauling ${formatter.format(oldB)}→${formatter.format(newB)}`);
                          if (oldCostRate != null && newCostRate != null && oldCostRate !== newCostRate) parts.push(`cost rate ${formatter.format(oldCostRate)}→${formatter.format(newCostRate)}`);
                          if (
                            (oldCostRate == null || newCostRate == null || oldCostRate === newCostRate) &&
                            currentCostRate != null &&
                            newCostRate != null &&
                            currentCostRate !== newCostRate
                          ) {
                            parts.push(`cost rate ${formatter.format(currentCostRate)}→${formatter.format(newCostRate)}`);
                          }
                          if (oldM != null && newM != null && oldM !== newM) parts.push(`material ${formatter.format(oldM)}→${formatter.format(newM)}`);
                          if (oldMCost != null && newMCost != null && oldMCost !== newMCost) parts.push(`material cost ${formatter.format(oldMCost)}→${formatter.format(newMCost)}`);
                          const changeStr = parts.length ? parts.join(', ') : (i18n.language === 'es' ? 'sin cambio' : 'no change');
                          return (
                            <MenuItem key={e.entry_id} value={`job_${e.entry_id}`}>
                              <Box display='flex' flexDirection='column'>
                                <Typography variant='body2'>Change on {dateStr}</Typography>
                                <Typography variant='body2' color='textSecondary'>
                                  {retroStr} • {changeStr}
                                </Typography>
                              </Box>
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </>
                )}
              </div>

              <div className='flex mx-6'>
                <Button
                  style={{ backgroundColor: 'white', border: '2px solid #000000', width: '25%' }}
                  onClick={handleCloseEdit}
                  disabled={updateTicketLoading}
                >
                  <Typography color={'black'}>{t('CANCEL')}</Typography>
                </Button>
                <Button
                  style={{ backgroundColor: '#edca33', width: '25%', marginLeft: '400px' }}
                  onClick={editTicket}
                  disabled={updateTicketLoading}
                >
                  <Typography color={'#FFFFFF'}>{t('UPDATE')}</Typography>
                </Button>
              </div>
            </DialogContent>
          </>
        )}
      </Dialog>

      <Dialog
        open={lastEditPreviewOpen}
        onClose={() => setLastEditPreviewOpen(false)}
        maxWidth='sm'
        fullWidth
      >
        <DialogTitle>
          {i18n.language === 'es'
            ? 'Corrección desde última edición'
            : 'Correction from last edit'}
        </DialogTitle>
        <DialogContent>
          {lastEditPreviewLoading ? (
            <Typography>
              {i18n.language === 'es' ? 'Cargando…' : 'Loading…'}
            </Typography>
          ) : !lastEditPreview ? (
            <Typography>
              {i18n.language === 'es'
                ? 'No se encontró información de edición.'
                : 'No edit information found.'}
            </Typography>
          ) : !lastEditPreview.needs_correction ||
            !(lastEditPreview.changes || []).length ? (
            <Typography>
              {i18n.language === 'es'
                ? 'Este ticket ya coincide con el último valor editado. No hay cambios que aplicar.'
                : 'This ticket already matches the last edited values. Nothing to apply.'}
            </Typography>
          ) : (
            <>
              <Typography variant='body2' style={{ marginBottom: 12 }}>
                {i18n.language === 'es'
                  ? 'Solo se muestran los valores que cambian respecto a la última edición manual.'
                  : 'Only values that differ from the last manual edit are shown.'}
              </Typography>
              <Box component='ul' sx={{ pl: 2, m: 0 }}>
                {(lastEditPreview.changes || []).map((c) => (
                  <li key={c.field} style={{ marginBottom: 6 }}>
                    <Typography variant='body2' style={{ fontWeight: 700 }}>
                      <strong>{c.label}</strong>:{' '}
                      {c.from == null ? '—' : String(c.from)} →{' '}
                      {c.to == null ? '—' : String(c.to)}
                    </Typography>
                  </li>
                ))}
              </Box>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLastEditPreviewOpen(false)}>
            {t('CANCEL')}
          </Button>
          {lastEditPreview?.needs_correction &&
            (lastEditPreview.changes || []).length > 0 && (
              <Button
                style={{ backgroundColor: '#edca33' }}
                onClick={applyLastEditPreviewToForm}
              >
                <Typography color='#000'>
                  {i18n.language === 'es' ? 'Aplicar al formulario' : 'Apply to form'}
                </Typography>
              </Button>
            )}
        </DialogActions>
      </Dialog>

      {/**modal for request edit ticket here*/}
      <Dialog
        open={openreq_edit}
        onClose={(e) => {
          setopenreq_edit(false);
          setModalShow(false);
        }}
        PaperProps={{
          style: {
            backgroundColor: 'black',
            boxShadow: 'none',
          },
        }}
        classes={{
          paper: 'm-24',
        }}
        maxWidth={'md'}
      >
        <DialogContent>
          <DialogContentText color={'#FFFFFF'}>
            {t('ARE_YOU_SURE_YOU_WANT_TO_EDIT')}
          </DialogContentText>
          <TextField
            value={req_reason}
            onChange={(e) => setreq_reason(e.target.value)}
            className='mt-8 mb-16 '
            id='reason'
            label={t('REASON')}
            variant='outlined'
            fullWidth
            multiline
            rows={3}
            style={{ backgroundColor: '#FFFFFF' }}
          />
          <div className='flex mx-6'>
            <Button
              fullWidth
              style={{ backgroundColor: '#edca33' }}
              onClick={(e) => {
                setopenreq_edit(false);
                setModalShow(false);
              }}
            >
              <Typography color={'black'}>{t('NO')}</Typography>
            </Button>
            <Button fullWidth style={{ backgroundColor: '#FF0000' }} onClick={req_edit_ticket}>
              <Typography color={'black'}>{t('YES')}</Typography>
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/**modal for request delete ticket */}
      <Dialog
        open={openreq_delete}
        onClose={(e) => {
          setopenreq_delete(false);
          setModalShow(false);
        }}
        PaperProps={{
          style: {
            backgroundColor: 'black',
            boxShadow: 'none',
          },
        }}
        classes={{
          paper: 'm-24',
        }}
        maxWidth={'md'}
      >
        <DialogContent>
          <DialogContentText color={'#FFFFFF'}>
            {t('ARE_YOU_SURE_YOU_WANT_TO_DELETE')}
          </DialogContentText>
          <TextField
            value={req_reason}
            onChange={(e) => setreq_reason(e.target.value)}
            className='mt-8 mb-16 '
            id='reason'
            label={t('REASON')}
            variant='outlined'
            fullWidth
            multiline
            rows={3}
            style={{ backgroundColor: '#FFFFFF' }}
          />
          <div className='flex mx-6'>
            <Button
              fullWidth
              style={{ backgroundColor: '#edca33' }}
              onClick={(e) => {
                setopenreq_delete(false);
                setModalShow(false);
              }}
            >
              <Typography color={'black'}>{t('NO')}</Typography>
            </Button>
            <Button fullWidth style={{ backgroundColor: '#FF0000' }} onClick={req_delete_ticket}>
              <Typography color={'black'}>{t('YES')}</Typography>
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/** ask whether to send the updated invoice when the ticket is already invoiced */}
      <Dialog
        open={Boolean(invoiceEditConfirm.open)}
        onClose={() => setInvoiceEditConfirm({ open: false, invoice_no: null })}
      >
        <DialogTitle>
          {t('TICKET_ON_INVOICE_EDIT_TITLE', { defaultValue: 'Send updated invoice?' })}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t('TICKET_ON_INVOICE_EDIT_MESSAGE', {
              invoice_no: invoiceEditConfirm.invoice_no || '—',
              defaultValue:
                'This ticket is already on invoice {{invoice_no}}. Do you want to send the updated invoice to the customer?',
            })}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setInvoiceEditConfirm({ open: false, invoice_no: null });
              editTicket({ skipInvoiceConfirm: true, send_emails: false });
            }}
          >
            {t('NO')}
          </Button>
          <Button
            variant='contained'
            onClick={() => {
              setInvoiceEditConfirm({ open: false, invoice_no: null });
              editTicket({ skipInvoiceConfirm: true, send_emails: true });
            }}
          >
            {t('TICKET_ON_INVOICE_EDIT_CONTINUE', { defaultValue: 'Yes, send invoice' })}
          </Button>
        </DialogActions>
      </Dialog>

      {/** confirm transfer off a $0 unpaid invoice */}
      <Dialog
        open={Boolean(zeroInvoiceConfirm.open)}
        onClose={() =>
          setZeroInvoiceConfirm({ open: false, invoice_no: null, message: '', payload: null })
        }
      >
        <DialogTitle>
          {t('ZERO_INVOICE_TRANSFER_CONFIRM_TITLE', {
            defaultValue: 'Invoice is $0.00 and not paid',
          })}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {zeroInvoiceConfirm.message ||
              t('ZERO_INVOICE_TRANSFER_CONFIRM_MESSAGE', {
                invoice_no: zeroInvoiceConfirm.invoice_no || '—',
                defaultValue:
                  'These tickets are on invoice {{invoice_no}} with a $0.00 total and no payments. This invoice is not paid. Do you want to transfer them? They will be removed from that invoice.',
              })}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setZeroInvoiceConfirm({ open: false, invoice_no: null, message: '', payload: null })
            }
          >
            {t('CANCEL')}
          </Button>
          <Button
            variant='contained'
            onClick={() => {
              const pending = zeroInvoiceConfirm.payload;
              setZeroInvoiceConfirm({ open: false, invoice_no: null, message: '', payload: null });
              JobTransfer(true, pending);
            }}
          >
            {t('ZERO_INVOICE_TRANSFER_CONFIRM_CONTINUE', { defaultValue: 'Yes, transfer' })}
          </Button>
        </DialogActions>
      </Dialog>

      {/**modal for request transfer ticket */}
      <Dialog
        fullWidth={false}
        maxWidth={'sm'}
        open={openreq_transfer}
        onClose={() => {
          setopenreq_transfer(false);
          setNewTicketJob();
          setModalShow(false);
          setTransferSearch('');
        }}
      >
        <DialogTitle>{t('TICKET_JOB_TRANSFER')}</DialogTitle>
        <DialogContent className='flex flex-col' sx={{ width: 450 }}>
          <Autocomplete
            disableListWrap
            id='job-transfer-box'
            clearOnBlur={false}
            freeSolo={true}
            value={newticketjob}
            onChange={(e, newValue) => {
              setNewTicketJob(newValue);
            }}
            options={allJobs}
            loading={true}
            sx={{ width: 300, padding: 0 }}
            ListboxProps={{
              onScroll: async (event) => {
                const listboxNode = event.currentTarget;
                if (listboxNode.scrollTop + listboxNode.clientHeight === listboxNode.scrollHeight) {
                  if (openreq_transfer && hasNextJob) {
                    if (transfersearch.length > 0) {
                      if (transfersearch.replace(/\s/g, '').length > 0) {
                        await searchJobs(
                          {
                            page: jobPage + 1,
                            text: event.target.value,
                            search: 'archive',
                            compacctnum,
                          },
                          (error) => {
                            //console.log(error);
                          }
                        );
                      }
                    } else {
                      getAllJobs({ page: jobPage + 1, filter: null, compacctnum });
                    }
                  }
                }
              },
              style: { maxHeight: '15rem' },
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={t('JOB')}
                sx={{ padding: 0 }}
                onChange={(e) => handleSearch(e)}
              />
            )}
            renderOption={(props, option) => <li {...props}>{option.label}</li>}
          />
          <TextField
            value={req_reason}
            onChange={(e) => setreq_reason(e.target.value)}
            className='mt-8 mb-16 '
            id='reason'
            label={t('REASON')}
            variant='outlined'
            fullWidth
            multiline
            rows={3}
            style={{ backgroundColor: '#FFFFFF' }}
          />
          <div className=' flex flex-row pl-16 items-center'>
            <Button variant='contained' sx={{ height: '45px' }} onClick={req_transfer_ticket}>
              <Typography fontWeight={'bold'}>{t('TRANSFER')}</Typography>
            </Button>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setopenreq_transfer(false);
              setNewTicketJob();
              setModalShow(false);
            }}
          >
            {t('CLOSE')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

// injectReducer(AuthReducer)
const mapStateToProps = (state) => {
  return {
    jobTickets: state.loadz_jobs_ticket?.JobTicketReducer?.jobTickets,
    hasNextPage: state.loadz_jobs_ticket?.JobTicketReducer?.hasNextPage,
    loading: state.loadz_jobs_ticket?.JobTicketReducer?.loading,
    page: state.loadz_jobs_ticket?.JobTicketReducer?.page,
    trucks: state.loadz_jobs_ticket?.JobTicketReducer?.trucks,
    drivers: state.loadz_jobs_ticket?.JobTicketReducer?.drivers,
    jobs: state.loadz_jobs?.JobReducer?.jobs,
    hasNextJob: state.loadz_jobs?.JobReducer?.hasNextPage,
    jobLoading: state.loadz_jobs?.JobReducer?.loading,
    jobPage: state.loadz_jobs?.JobReducer?.page,
    user: state.loadz_auth?.AuthReducer?.user,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getAllTicketJobs: (payload, onError, onSuccess) =>
    dispatch(JobTicketAction.getAllTicketJob(payload, onError, onSuccess)),
  searchJobTickets: (payload, onError, onSuccess) =>
    dispatch(JobTicketAction.searchJobTicket(payload, onError, onSuccess)),
  transferJobTickets: (payload, onSuccess, onError) =>
    dispatch(JobTicketAction.transferJobTickets(payload, onSuccess, onError)),
  getTrucks: (payload, onError) => dispatch(JobTicketAction.getTrucks(payload, onError)),
  getDrivers: (payload, onError) => dispatch(JobTicketAction.getDrivers(payload, onError)),
  deleteJobTickets: (payload, onSuccess, onError) =>
    dispatch(JobTicketAction.deleteJobTickets(payload, onSuccess, onError)),
  editJobTicket: (data, onSuccess, onError) =>
    dispatch(JobTicketAction.editJobTicket(data, onSuccess, onError)),
  getAllJobs: (payload, onError) => dispatch(JobAction.getJobs(payload, onError)),
  logout: () => dispatch(AuthAction.logout()),
  searchJobs: (payload, onError) => dispatch(JobAction.searchJobs(payload, onError)),
});

function ValidateNumericFields(
  tk_qty,
  tk_rate,
  tk_cost,
  tk_mat_rate,
  tk_mat_cost,
  tk_scale_no,
  jobScale,
  t
) {
  // Only number validation

  let warningFields = [];
  let messageFlag = false;
  const decimalNumberRegex = /^[0-9]*\.?[0-9]*$/;
  if (!decimalNumberRegex.test(parseFloat(tk_qty))) {
    messageFlag = true;
    warningFields.push(t('QTY'));
  }
  if (!decimalNumberRegex.test(parseFloat(tk_rate))) {
    messageFlag = true;
    warningFields.push(t('HAULING_INVOICE_RATE'));
  }
  if (!decimalNumberRegex.test(parseFloat(tk_cost))) {
    messageFlag = true;
    warningFields.push(t('HAULING_COST_RATE'));
  }
  if (!decimalNumberRegex.test(parseFloat(tk_mat_rate))) {
    messageFlag = true;
    warningFields.push(t('MATERIAL_INVOICE_RATE'));
  }
  if (!decimalNumberRegex.test(parseFloat(tk_mat_cost))) {
    messageFlag = true;
    warningFields.push(t('MATERIAL_COST_RATE'));
  }
  if (jobScale && !decimalNumberRegex.test(parseFloat(tk_scale_no))) {
    messageFlag = true;
    warningFields.push(t('SCALE_NO'));
  }

  return {
    messageFlag,
    warningFields,
  };
}

export default withReducer(
  'loadz_jobs_ticket',
  JobTicketReducer
)(connect(mapStateToProps, mapDispatchToProps)(TicketsTable));
